var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNimaz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3572 74.6469C47.3439 76.8336 55.2236 74.6236 57.4571 70.1272C60.0823 64.8424 59.1321 62.7092 61.0775 60.6751C63.6017 58.0359 67.4135 56.9672 70.0217 54.4112C72.9932 51.4991 73.9475 46.7186 72.322 42.8888C71.219 40.29 69.1137 38.2439 67.7993 35.7452C66.5619 33.3927 66.0644 30.6575 66.3943 28.0199C66.5281 26.9511 66.7715 23.4941 64.2945 19.7367C60.503 13.9853 54.9031 12.5416 49.1884 12.1912C39.4111 11.5917 37.9891 17.7252 33.2188 19.3159C29.547 20.5404 26.2361 17.2591 19.1593 20.7493C13.0031 23.7855 11.9129 29.7784 12.4729 34.6053C13.2031 40.8996 9.6169 43.9728 10.2329 47.6256C11.5825 55.6285 18.7094 52.9941 20.2468 58.3887C20.8348 60.4519 21.4201 62.5183 22.2862 64.4812C23.6283 67.5229 26.1004 68.6213 27.2958 68.9416C32.8617 70.4333 34.2591 71.2221 42.3572 74.6469Z",
    fill: "#FFF1E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.233 54.9546C15.233 54.9546 17.793 55.7456 18.793 57.5772C19.793 59.4087 20.873 63.5436 19.393 64.2562C17.913 64.9687 17.793 63.5463 14.673 60.0175C11.553 56.4887 11.8756 54.0738 15.233 54.9546Z",
    fill: "#FFF1E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.953 30.2087C66.953 30.2087 67.193 34.5287 69.073 36.4087C70.953 38.2887 73.273 37.2487 71.873 32.8487C70.473 28.4487 66.913 27.0887 66.953 30.2087Z",
    fill: "#FFF1E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0147 46.9412V24.1339C53.0147 21.5308 51.8544 20.1246 50.8808 19.4028C50.5013 19.1211 50.1201 18.9224 49.7832 18.7827C49.9134 17.2673 49.9401 15.5073 47.9489 13.8328C44.9769 11.3334 41.7971 11.1286 40.6222 8.65099C40.5728 8.54667 40.427 8.54667 40.3776 8.65099C39.2027 11.1284 36.0229 11.3334 33.0509 13.8328C31.0597 15.5073 31.0864 17.2673 31.2166 18.7827C30.8797 18.9224 30.4987 19.1211 30.119 19.4028C29.1454 20.1246 27.9851 21.5307 27.9851 24.1339V46.9412",
    stroke: "#F29417",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0147 46.9412V24.1339C53.0147 21.5308 51.8544 20.1246 50.8808 19.4028C50.5013 19.1211 50.1201 18.9224 49.7832 18.7827C49.9134 17.2673 49.9401 15.5073 47.9489 13.8328C44.9769 11.3334 41.7971 11.1286 40.6222 8.65099C40.5728 8.54667 40.427 8.54667 40.3776 8.65099C39.2027 11.1284 36.0229 11.3334 33.0509 13.8328C31.0597 15.5073 31.0864 17.2673 31.2166 18.7827C30.8797 18.9224 30.4987 19.1211 30.119 19.4028C29.1454 20.1246 27.9851 21.5307 27.9851 24.1339V46.9412",
    fill: "#380E0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8907 35.0813C51.8907 35.0813 52.6175 34.7195 52.4468 33.953C52.2983 33.2877 51.0644 32.8511 50.7241 32.5283C50.7241 32.5283 50.6844 32.4933 50.6638 32.4639C50.643 32.4933 50.6035 32.5283 50.6035 32.5283C50.2631 32.8511 49.0292 33.2877 48.8807 33.953C48.7099 34.7194 49.4369 35.0813 49.4369 35.0813V37.5591H49.1268C49.1268 37.765 49.2556 37.9405 49.4369 38.0104V41.8466H49.1268C49.1268 42.0525 49.2556 42.228 49.4369 42.2979V48.3512H51.8908V42.2979C52.0721 42.2279 52.2009 42.0525 52.2009 41.8466H51.8908V38.0104C52.0721 37.9403 52.2009 37.765 52.2009 37.5591H51.8908V35.0813H51.8907Z",
    fill: "#4F1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5627 35.0813C31.5627 35.0813 32.2896 34.7195 32.1189 33.953C31.9704 33.2877 30.7365 32.8511 30.3962 32.5283C30.3962 32.5283 30.3567 32.4933 30.3359 32.4639C30.3151 32.4933 30.2755 32.5283 30.2755 32.5283C29.9351 32.8511 28.7013 33.2877 28.5528 33.953C28.3821 34.7194 29.109 35.0813 29.109 35.0813V37.5591H28.7989C28.7989 37.765 28.9277 37.9405 29.109 38.0104V41.8466H28.7989C28.7989 42.0525 28.9277 42.228 29.109 42.2979V48.3512H31.5629V42.2979C31.7442 42.2279 31.873 42.0525 31.873 41.8466H31.5629V38.0104C31.7442 37.9403 31.873 37.765 31.873 37.5591H31.5629L31.5627 35.0813Z",
    fill: "#4F1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1463 38.0726C48.8964 36.9526 46.8194 36.2176 46.2463 35.6744C46.2463 35.6744 46.1796 35.6154 46.1447 35.5659C46.1098 35.6154 46.0431 35.6744 46.0431 35.6744C45.4702 36.2176 43.393 36.9526 43.1431 38.0726C42.8556 39.3629 44.0793 39.972 44.0793 39.972V45.2494H48.21V39.972C48.21 39.972 49.4338 39.3629 49.1463 38.0726Z",
    fill: "#441717"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8563 38.0726C37.6064 36.9526 35.5292 36.2176 34.9563 35.6744C34.9563 35.6744 34.8896 35.6154 34.8547 35.5659C34.8198 35.6154 34.7531 35.6744 34.7531 35.6744C34.1801 36.2176 32.103 36.9526 31.8531 38.0726C31.5656 39.3629 32.7892 39.972 32.7892 39.972V45.2494H36.92V39.972C36.92 39.972 38.1438 39.3629 37.8563 38.0726Z",
    fill: "#441717"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6872 33.2687C45.2554 31.4767 41.6656 30.3012 40.6755 29.4326C40.7909 29.4094 40.8703 29.3647 40.8703 29.3129C40.8703 29.2468 40.7431 29.1916 40.5739 29.179V28.0681L40.5853 28.0682C41.4614 28.0369 42.1847 27.4036 42.3504 26.5686C42.3495 26.5705 42.3488 26.5722 42.3475 26.574C42.0957 27.1022 41.557 27.4671 40.933 27.4671C40.0674 27.4671 39.3659 26.7655 39.3659 25.9002C39.3659 25.1039 39.9597 24.4465 40.729 24.3465C40.6595 24.3385 40.5893 24.3345 40.5178 24.3345C39.4858 24.3345 38.6493 25.171 38.6493 26.203C38.6493 27.1998 39.4307 28.0122 40.4144 28.0662L40.4258 28.0663V29.1791C40.2568 29.1918 40.1294 29.247 40.1294 29.313C40.1294 29.3649 40.2086 29.4095 40.3242 29.4327C39.3341 30.3014 35.7443 31.4769 35.3125 33.2689C34.8154 35.3319 36.9303 36.3065 36.9303 36.3065V44.246H40.4999H44.0694V36.3065C44.0694 36.3065 46.1843 35.3318 45.6872 33.2687Z",
    fill: "#4F1A1A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M45.6873 33.2681C45.5705 32.7833 45.2217 32.3433 44.7561 31.9417H44.7545C44.7545 31.9417 45.7801 34.6488 40.5001 34.6488C35.2201 34.6488 36.2457 31.9417 36.2457 31.9417H36.2441C35.7785 32.3433 35.4297 32.7833 35.3129 33.2681C34.8153 35.3321 36.9305 36.3064 36.9305 36.3064V44.2457H40.5001H44.0697V36.3064C44.0697 36.3064 46.1849 35.3321 45.6873 33.2681Z",
    fill: "#4F1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3889 43.7247H38.6108V39.288C38.6108 38.2447 39.4566 37.3989 40.5 37.3989C41.5433 37.3989 42.3891 38.2447 42.3891 39.288V43.7247H42.3889Z",
    fill: "#441717"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9642 37.5588H29.7075V36.0832C29.7075 35.7361 29.9888 35.4548 30.3358 35.4548C30.6829 35.4548 30.9642 35.7361 30.9642 36.0832V37.5588Z",
    fill: "#441717"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2923 37.5588H50.0356V36.0832C50.0356 35.7361 50.3169 35.4548 50.664 35.4548C51.011 35.4548 51.2923 35.7361 51.2923 36.0832V37.5588Z",
    fill: "#441717"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1066 26.6486C43.2723 26.6486 43.4066 26.5143 43.4066 26.3486C43.4066 26.1829 43.2723 26.0486 43.1066 26.0486C42.941 26.0486 42.8066 26.1829 42.8066 26.3486C42.8066 26.5143 42.941 26.6486 43.1066 26.6486Z",
    fill: "#683434"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3265 26.9288C51.4867 26.9288 51.6165 26.7989 51.6165 26.6387C51.6165 26.4785 51.4867 26.3486 51.3265 26.3486C51.1663 26.3486 51.0364 26.4785 51.0364 26.6387C51.0364 26.7989 51.1663 26.9288 51.3265 26.9288Z",
    fill: "#4F1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4 22.1517C32.4 22.319 32.2643 22.4547 32.097 22.4547C31.9296 22.4547 31.7939 22.319 31.7939 22.1517C31.7939 21.9843 31.9296 21.8486 32.097 21.8486C32.2643 21.8486 32.4 21.9843 32.4 22.1517Z",
    fill: "#602B2B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1335 27.2087C48.2882 27.2087 48.4135 27.0833 48.4135 26.9287C48.4135 26.774 48.2882 26.6487 48.1335 26.6487C47.9789 26.6487 47.8535 26.774 47.8535 26.9287C47.8535 27.0833 47.9789 27.2087 48.1335 27.2087Z",
    fill: "#4F1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7576 30.6487C35.8791 30.6487 35.9776 30.5502 35.9776 30.4287C35.9776 30.3072 35.8791 30.2087 35.7576 30.2087C35.6361 30.2087 35.5376 30.3072 35.5376 30.4287C35.5376 30.5502 35.6361 30.6487 35.7576 30.6487Z",
    fill: "#683434"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7197 31.8747C29.7197 31.9637 29.6475 32.0359 29.5586 32.0359C29.4696 32.0359 29.3975 31.9637 29.3975 31.8747C29.3975 31.7858 29.4696 31.7136 29.5586 31.7136C29.6475 31.7135 29.7197 31.7856 29.7197 31.8747Z",
    fill: "#683434"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5652 15.4697C34.6542 15.4697 34.7263 15.3976 34.7263 15.3086C34.7263 15.2196 34.6542 15.1475 34.5652 15.1475C34.4762 15.1475 34.4041 15.2196 34.4041 15.3086C34.4041 15.3976 34.4762 15.4697 34.5652 15.4697Z",
    fill: "#683434"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3269 20.0498C38.4159 20.0498 38.488 19.9776 38.488 19.8887C38.488 19.7997 38.4159 19.7275 38.3269 19.7275C38.2379 19.7275 38.1658 19.7997 38.1658 19.8887C38.1658 19.9776 38.2379 20.0498 38.3269 20.0498Z",
    fill: "#683434"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0063 13.7954C41.0953 13.7954 41.1675 13.7232 41.1675 13.6343C41.1675 13.5453 41.0953 13.4731 41.0063 13.4731C40.9173 13.4731 40.8452 13.5453 40.8452 13.6343C40.8452 13.7232 40.9173 13.7954 41.0063 13.7954Z",
    fill: "#683434"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3264 11.9287C39.4154 11.9287 39.4875 11.8565 39.4875 11.7676C39.4875 11.6786 39.4154 11.6064 39.3264 11.6064C39.2374 11.6064 39.1653 11.6786 39.1653 11.7676C39.1653 11.8565 39.2374 11.9287 39.3264 11.9287Z",
    fill: "#683434"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9849 20.0498C46.0738 20.0498 46.146 19.9776 46.146 19.8887C46.146 19.7997 46.0738 19.7275 45.9849 19.7275C45.8959 19.7275 45.8237 19.7997 45.8237 19.8887C45.8237 19.9776 45.8959 20.0498 45.9849 20.0498Z",
    fill: "#683434"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3286 23.1299C41.4176 23.1299 41.4897 23.0577 41.4897 22.9687C41.4897 22.8798 41.4176 22.8076 41.3286 22.8076C41.2396 22.8076 41.1675 22.8798 41.1675 22.9687C41.1675 23.0577 41.2396 23.1299 41.3286 23.1299Z",
    fill: "#683434"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0803 24.1203C50.1693 24.1203 50.2414 24.0482 50.2414 23.9592C50.2414 23.8702 50.1693 23.7981 50.0803 23.7981C49.9913 23.7981 49.9192 23.8702 49.9192 23.9592C49.9192 24.0482 49.9913 24.1203 50.0803 24.1203Z",
    fill: "#683434"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5976 27.9182C34.5976 28.0072 34.5255 28.0793 34.4365 28.0793C34.3476 28.0793 34.2754 28.0072 34.2754 27.9182C34.2754 27.8292 34.3476 27.7571 34.4365 27.7571C34.5255 27.7571 34.5976 27.8292 34.5976 27.9182Z",
    fill: "#683434"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0063 24.6565C31.0953 24.6565 31.1675 24.5843 31.1675 24.4953C31.1675 24.4064 31.0953 24.3342 31.0063 24.3342C30.9173 24.3342 30.8452 24.4064 30.8452 24.4953C30.8452 24.5843 30.9173 24.6565 31.0063 24.6565Z",
    fill: "#683434"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8315 15.8908C39.9205 15.8908 39.9927 15.8187 39.9927 15.7297C39.9927 15.6407 39.9205 15.5686 39.8315 15.5686C39.7425 15.5686 39.6704 15.6407 39.6704 15.7297C39.6704 15.8187 39.7425 15.8908 39.8315 15.8908Z",
    fill: "#683434"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 12.4724C43.849 12.4724 43.9211 12.4002 43.9211 12.3113C43.9211 12.2223 43.849 12.1501 43.76 12.1501C43.671 12.1501 43.5989 12.2223 43.5989 12.3113C43.5989 12.4002 43.671 12.4724 43.76 12.4724Z",
    fill: "#683434"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9211 29.7087C43.9211 29.7977 43.849 29.8698 43.76 29.8698C43.671 29.8698 43.5989 29.7977 43.5989 29.7087C43.5989 29.6198 43.671 29.5476 43.76 29.5476C43.849 29.5476 43.9211 29.6198 43.9211 29.7087Z",
    fill: "#683434"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2129 19.2888C43.5001 19.2888 43.7329 19.056 43.7329 18.7688C43.7329 18.4816 43.5001 18.2488 43.2129 18.2488C42.9257 18.2488 42.6929 18.4816 42.6929 18.7688C42.6929 19.056 42.9257 19.2888 43.2129 19.2888Z",
    fill: "#562222"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0915 19.2888C40.2351 19.2888 40.3515 19.1724 40.3515 19.0288C40.3515 18.8852 40.2351 18.7688 40.0915 18.7688C39.9479 18.7688 39.8315 18.8852 39.8315 19.0288C39.8315 19.1724 39.9479 19.2888 40.0915 19.2888Z",
    fill: "#4F1A1A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9966 17.1103C48.1402 17.1103 48.2566 16.9939 48.2566 16.8503C48.2566 16.7067 48.1402 16.5903 47.9966 16.5903C47.853 16.5903 47.7366 16.7067 47.7366 16.8503C47.7366 16.9939 47.853 17.1103 47.9966 17.1103Z",
    fill: "#4F1A1A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1043 27.4523C30.1043 27.5867 29.9954 27.6956 29.8608 27.6956C29.7262 27.6956 29.6174 27.5867 29.6174 27.4523C29.6174 27.3179 29.7264 27.2087 29.8608 27.2087C29.9952 27.2087 30.1043 27.3177 30.1043 27.4523Z",
    fill: "#4F1A1A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6298 31.3717C46.6298 31.528 46.5031 31.6547 46.3468 31.6547C46.1904 31.6547 46.0637 31.528 46.0637 31.3717C46.0637 31.2153 46.1904 31.0886 46.3468 31.0886C46.5031 31.0886 46.6298 31.2153 46.6298 31.3717Z",
    fill: "#4F1A1A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3304 30.9289C50.4685 30.9289 50.5805 30.8169 50.5805 30.6788C50.5805 30.5407 50.4685 30.4287 50.3304 30.4287C50.1923 30.4287 50.0803 30.5407 50.0803 30.6788C50.0803 30.8169 50.1923 30.9289 50.3304 30.9289Z",
    fill: "#562222"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8449 23.8147C43.8449 23.9505 43.7347 24.0608 43.5989 24.0608C43.463 24.0608 43.3528 23.9505 43.3528 23.8147C43.3528 23.6788 43.463 23.5686 43.5989 23.5686C43.7347 23.5686 43.8449 23.6788 43.8449 23.8147Z",
    fill: "#4F1A1A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1952 14.5287C37.2835 14.5287 37.3552 14.4571 37.3552 14.3687C37.3552 14.2804 37.2835 14.2087 37.1952 14.2087C37.1068 14.2087 37.0352 14.2804 37.0352 14.3687C37.0352 14.4571 37.1068 14.5287 37.1952 14.5287Z",
    fill: "#602B2B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.415 15.5686C45.5586 15.5686 45.675 15.4522 45.675 15.3086C45.675 15.165 45.5586 15.0486 45.415 15.0486C45.2714 15.0486 45.155 15.165 45.155 15.3086C45.155 15.4522 45.2714 15.5686 45.415 15.5686Z",
    fill: "#602B2B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5967 20.5088C49.768 20.5088 49.9068 20.37 49.9068 20.1988C49.9068 20.0275 49.768 19.8887 49.5967 19.8887C49.4255 19.8887 49.2866 20.0275 49.2866 20.1988C49.2866 20.37 49.4255 20.5088 49.5967 20.5088Z",
    fill: "#602B2B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7367 22.3073C47.7367 22.3932 47.6669 22.463 47.581 22.463C47.4951 22.463 47.4253 22.3932 47.4253 22.3073C47.4253 22.2214 47.4949 22.1516 47.581 22.1516C47.6671 22.1516 47.7367 22.2214 47.7367 22.3073Z",
    fill: "#4F1A1A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1735 23.9592C37.2813 23.9592 37.3687 23.8719 37.3687 23.764C37.3687 23.6562 37.2813 23.5688 37.1735 23.5688C37.0657 23.5688 36.9783 23.6562 36.9783 23.764C36.9783 23.8719 37.0657 23.9592 37.1735 23.9592Z",
    fill: "#4F1A1A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3754 30.4287C32.4804 30.4287 32.5655 30.3436 32.5655 30.2387C32.5655 30.1337 32.4804 30.0486 32.3754 30.0486C32.2704 30.0486 32.1853 30.1337 32.1853 30.2387C32.1853 30.3436 32.2704 30.4287 32.3754 30.4287Z",
    fill: "#562222"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6461 32.4721C34.7188 32.4721 34.7778 32.4131 34.7778 32.3404C34.7778 32.2677 34.7188 32.2087 34.6461 32.2087C34.5734 32.2087 34.5144 32.2677 34.5144 32.3404C34.5144 32.4131 34.5734 32.4721 34.6461 32.4721Z",
    fill: "#4F1A1A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7777 25.1497C34.7777 25.3382 34.6249 25.4908 34.4366 25.4908C34.2481 25.4908 34.0955 25.338 34.0955 25.1497C34.0955 24.9612 34.2483 24.8086 34.4366 24.8086C34.6251 24.8086 34.7777 24.9614 34.7777 25.1497Z",
    fill: "#4F1A1A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5087 22.3527C29.7031 22.3527 29.8607 22.1951 29.8607 22.0007C29.8607 21.8063 29.7031 21.6487 29.5087 21.6487C29.3143 21.6487 29.1567 21.8063 29.1567 22.0007C29.1567 22.1951 29.3143 22.3527 29.5087 22.3527Z",
    fill: "#4F1A1A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7575 18.7891C35.7575 18.933 35.6408 19.0494 35.4971 19.0494C35.3533 19.0494 35.2368 18.9328 35.2368 18.7891C35.2368 18.6453 35.3535 18.5288 35.4971 18.5288C35.641 18.5286 35.7575 18.6453 35.7575 18.7891Z",
    fill: "#4F1A1A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5529 68.1343H19.447L25.8653 42.2681H55.1347L61.5529 68.1343Z",
    fill: "#7A2B2B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7916 66.869H22.1816L27.436 42.8953H53.545L58.7916 66.869Z",
    fill: "#F29417"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6968 44.7302L52.7118 63.8627H28.2882L31.3032 44.7302H49.6968ZM50.107 44.2502H30.893L27.7266 64.3427H53.2734L50.107 44.2502Z",
    fill: "#FFE4D4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0902 62.4312L34.3123 63.266L35.9961 64.1185L37.7751 63.266L36.0902 62.4312Z",
    fill: "#FFE4D4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4818 44.2502H40.915L42.2118 44.7306L43.4818 44.2502Z",
    fill: "#FFE4D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9727 61.3821L32.1965 62.1949L33.8354 63.0246L35.613 62.1949L33.9727 61.3821Z",
    fill: "#FFE4D4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2249 63.266L45.0039 64.1185L46.6877 63.266L44.9098 62.4312L43.2249 63.266Z",
    fill: "#FFE4D4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8779 44.2502L45.6351 44.7304L44.3123 44.2502H46.8779Z",
    fill: "#FFE4D4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8096 52.8751L46.37 53.5196L47.8225 52.8751L46.2632 52.2422L44.8096 52.8751Z",
    fill: "#FFE4D4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.019 64.3427H35.4317L33.795 63.5088L32.019 64.3427Z",
    fill: "#FFE4D4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1213 44.2502L35.3644 44.7306L36.6879 44.2502H34.1213Z",
    fill: "#FFE4D4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M31.911 60.3606L30.1372 61.152L31.7327 61.96L33.5084 61.152L31.911 60.3606Z",
    fill: "#FFE4D4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45.387 62.1949L47.1646 63.0246L48.8034 62.1949L47.0273 61.3821L45.387 62.1949Z",
    fill: "#FFE4D4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0196 46.8675L31.7169 46.3389L30.4934 46.7849L30.4673 46.9504L31.5682 47.4053L33.0196 46.8675Z",
    fill: "#FFE4D4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4188 47.2588L30.323 47.8666L31.1473 47.5612L30.4188 47.2588Z",
    fill: "#FFE4D4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8548 48.2702L31.5249 47.718L30.2732 48.1838L30.2458 48.3567L31.3697 48.8319L32.8548 48.2702Z",
    fill: "#FFE4D4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1951 48.6787L30.095 49.3139L30.9388 48.9947L30.1951 48.6787Z",
    fill: "#FFE4D4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0484 45.5244L45.7447 46.0393L44.355 45.5244L45.6593 45.0173L47.0484 45.5244Z",
    fill: "#FFE4D4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4917 61.152L49.2674 61.96L50.8629 61.152L49.0891 60.3606L47.4917 61.152Z",
    fill: "#FFE4D4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8718 46.1887L47.5694 46.7152L46.1479 46.1887L47.4531 45.6714L48.8718 46.1887Z",
    fill: "#FFE4D4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2645 44.8737L43.9602 45.3783L42.5977 44.8737L43.9044 44.3777L45.2645 44.8737Z",
    fill: "#FFE4D4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6331 45.8989L30.5413 46.4812L31.347 46.1887L30.6331 45.8989Z",
    fill: "#FFE4D4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0566 51.0948L49.4446 50.4937L47.9238 49.9033L46.5347 50.4937L48.0566 51.0948Z",
    fill: "#FFE4D4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6967 44.8737L47.4203 45.3783L46.0298 44.8737L47.3088 44.3777L48.6967 44.8737Z",
    fill: "#FFE4D4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8863 49.5691L49.2449 48.9947L47.7594 48.4302L46.3999 48.9947L47.8863 49.5691Z",
    fill: "#FFE4D4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M47.724 48.1108L49.0541 47.5612L47.6026 47.021L46.2712 47.5612L47.724 48.1108Z",
    fill: "#FFE4D4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6152 49.7357L46.1029 50.3232L47.4924 49.7357L46.0055 49.1584L44.6152 49.7357Z",
    fill: "#FFE4D4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2956 45.4449L50.3206 45.6034L49.2414 46.0393L47.823 45.5244L49.0992 45.0173L50.2956 45.4449Z",
    fill: "#FFE4D4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5244 48.2702L45.9782 48.8319L47.338 48.2702L45.8851 47.718L44.5244 48.2702Z",
    fill: "#FFE4D4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2345 52.6923L49.6532 52.0628L48.0954 51.4446L46.6753 52.0628L48.2345 52.6923Z",
    fill: "#FFE4D4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0847 64.3427H53.2734L53.2559 64.2323L51.6748 63.5088L50.0847 64.3427Z",
    fill: "#FFE4D4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7102 51.2692L46.2332 51.8842L47.6536 51.2692L46.1315 50.665L44.7102 51.2692Z",
    fill: "#FFE4D4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6822 49.7357L31.3241 49.1584L30.0426 49.6455L30.0142 49.8263L31.1618 50.3232L32.6822 49.7357Z",
    fill: "#FFE4D4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4375 46.8675L45.8589 47.4053L47.1903 46.8675L45.7698 46.3389L44.4375 46.8675Z",
    fill: "#FFE4D4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6456 45.5244L35.3407 45.0178L33.9509 45.5244L35.2552 46.0396L36.6456 45.5244Z",
    fill: "#FFE4D4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5183 44.2502L38.7882 44.7306L40.085 44.2502H37.5183Z",
    fill: "#FFE4D4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8519 46.1888L33.5478 45.6714L32.1284 46.1888L33.4316 46.7151L34.8519 46.1888Z",
    fill: "#FFE4D4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5356 64.3427H39.9483L38.2651 63.5088L36.5356 64.3427Z",
    fill: "#FFE4D4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 48.1108L41.8914 47.5612L40.4999 47.021L39.1084 47.5612L40.4999 48.1108Z",
    fill: "#FFE4D4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1784 63.7394L53.0301 62.7981L52.1379 63.2661L53.1784 63.7394Z",
    fill: "#FFE4D4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4644 64.3427L42.735 63.5088L41.0518 64.3427H44.4644Z",
    fill: "#FFE4D4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 49.5691L41.9225 48.9947L40.5 48.4302L39.0774 48.9947L40.5 49.5691Z",
    fill: "#FFE4D4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4015 44.8738L37.0959 44.3777L35.7351 44.8738L37.0402 45.3782L38.4015 44.8738Z",
    fill: "#FFE4D4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M48.981 64.3427L47.205 63.5088L45.5684 64.3427H48.981Z",
    fill: "#FFE4D4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.687 52.8751L50.2833 53.5196L51.4819 52.9743L51.4507 52.7761L50.1054 52.2422L48.687 52.8751Z",
    fill: "#FFE4D4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2182 57.6472L52.0915 56.8423L51.2612 57.2426L52.2182 57.6472Z",
    fill: "#FFE4D4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8853 54.5587L50.5224 55.235L51.748 54.6629L51.7152 54.4549L50.3357 53.895L48.8853 54.5587Z",
    fill: "#FFE4D4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1435 50.8277L51.0388 50.1631L50.2793 50.4936L51.1435 50.8277Z",
    fill: "#FFE4D4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3932 52.4126L51.2836 51.7166L50.5076 52.0628L51.3932 52.4126Z",
    fill: "#FFE4D4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4983 51.2692L50.0556 51.8842L51.2282 51.3639L51.1983 51.1746L49.8858 50.665L48.4983 51.2692Z",
    fill: "#FFE4D4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6212 61.3821L28.0851 62.0677L28.0449 62.3226L29.3924 63.0246L31.2163 62.1949L29.6212 61.3821Z",
    fill: "#FFE4D4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.093 56.3257L50.7732 57.0361L52.0271 56.4351L51.9927 56.2166L50.5772 55.6289L49.093 56.3257Z",
    fill: "#FFE4D4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6802 62.4312L29.8557 63.266L31.4922 64.1185L33.3186 63.266L31.6802 62.4312Z",
    fill: "#FFE4D4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9298 55.8163L51.8092 55.0505L50.9978 55.4313L51.9298 55.8163Z",
    fill: "#FFE4D4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M51.655 54.0735L51.5401 53.3438L50.7468 53.7068L51.655 54.0735Z",
    fill: "#FFE4D4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3673 45.8987L50.459 46.4812L49.6531 46.1886L50.3673 45.8987Z",
    fill: "#FFE4D4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1074 44.2502L50.1172 44.3125L49.0592 44.7304L47.7095 44.2502H50.1074Z",
    fill: "#FFE4D4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.97 44.8738L33.6921 44.3777L32.3035 44.8738L33.5806 45.3782L34.97 44.8738Z",
    fill: "#FFE4D4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7586 46.0396L33.1778 45.5244L31.901 45.0178L30.7046 45.4452L30.6797 45.6037L31.7586 46.0396Z",
    fill: "#FFE4D4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3179 49.7357L49.8382 50.3232L50.9859 49.8263L50.9574 49.6455L49.676 49.1584L48.3179 49.7357Z",
    fill: "#FFE4D4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50.507 46.7847L50.533 46.9503L49.4319 47.4052L47.9812 46.8677L49.2833 46.3386L50.507 46.7847Z",
    fill: "#FFE4D4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1453 48.2702L49.6304 48.8319L50.7542 48.3567L50.7269 48.1838L49.4752 47.718L48.1453 48.2702Z",
    fill: "#FFE4D4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M50.905 49.3139L50.805 48.6787L50.0613 48.9947L50.905 49.3139Z",
    fill: "#FFE4D4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M50.162 44.5964L50.2498 45.154L49.4617 44.8737L50.162 44.5964Z",
    fill: "#FFE4D4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6117 58.7258L28.4783 59.5727L29.4615 59.1468L28.6117 58.7258Z",
    fill: "#FFE4D4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 46.7151L41.8617 46.1888L40.4999 45.6714L39.1382 46.1888L40.4999 46.7151Z",
    fill: "#FFE4D4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1147 54.5587L30.6643 53.895L29.2848 54.4549L29.252 54.6629L30.4776 55.235L32.1147 54.5587Z",
    fill: "#FFE4D4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3115 58.1828L51.0371 58.9299L52.3208 58.2977L52.2846 58.0681L50.8309 57.4502L49.3115 58.1828Z",
    fill: "#FFE4D4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9069 56.3257L30.4227 55.6289L29.0072 56.2166L28.9727 56.4351L30.2267 57.0361L31.9069 56.3257Z",
    fill: "#FFE4D4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7162 51.7166L29.6064 52.4126L30.4922 52.0628L29.7162 51.7166Z",
    fill: "#FFE4D4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5016 51.2692L31.1141 50.665L29.8016 51.1746L29.7717 51.3639L30.9444 51.8842L32.5016 51.2692Z",
    fill: "#FFE4D4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9085 56.8423L28.7817 57.6472L29.7387 57.2426L28.9085 56.8423Z",
    fill: "#FFE4D4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3128 52.8751L30.8945 52.2422L29.5493 52.7761L29.5181 52.9743L30.7166 53.5196L32.3128 52.8751Z",
    fill: "#FFE4D4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4598 53.3438L29.345 54.0735L30.2531 53.7068L29.4598 53.3438Z",
    fill: "#FFE4D4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M29.191 55.0505L29.0703 55.8163L30.0023 55.4313L29.191 55.0505Z",
    fill: "#FFE4D4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8414 61.6007L52.7007 60.7085L51.8303 61.152L52.8414 61.6007Z",
    fill: "#FFE4D4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5415 60.1365L51.3148 60.9234L52.6297 60.2575L52.5916 60.0157L51.0978 59.3655L49.5415 60.1365Z",
    fill: "#FFE4D4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2992 60.7085L28.1587 61.6007L29.1697 61.152L28.2992 60.7085Z",
    fill: "#FFE4D4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3787 61.3821L49.7837 62.1949L51.6075 63.0246L52.955 62.3226L52.9149 62.0677L51.3787 61.3821Z",
    fill: "#FFE4D4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6885 58.1828L30.1691 57.4502L28.7154 58.0681L28.6792 58.2977L29.9629 58.9299L31.6885 58.1828Z",
    fill: "#FFE4D4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6814 63.266L49.5078 64.1185L51.1443 63.266L49.3198 62.4312L47.6814 63.266Z",
    fill: "#FFE4D4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4585 60.1365L29.9022 59.3655L28.4084 60.0157L28.3704 60.2575L29.6852 60.9234L31.4585 60.1365Z",
    fill: "#FFE4D4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29.961 50.1631L29.8562 50.8277L30.7205 50.4936L29.961 50.1631Z",
    fill: "#FFE4D4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6769 47.8666L50.581 47.2588L49.8525 47.5612L50.6769 47.8666Z",
    fill: "#FFE4D4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9224 51.2692L42.4112 51.8842L43.8659 51.2692L42.3772 50.665L40.9224 51.2692Z",
    fill: "#FFE4D4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9426 54.5587L42.5044 55.235L44.0284 54.5587L42.4671 53.895L40.9426 54.5587Z",
    fill: "#FFE4D4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3673 52.6923L45.8212 52.0628L44.2978 51.4446L42.8433 52.0628L44.3673 52.6923Z",
    fill: "#FFE4D4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9321 52.8751L42.4566 53.5196L43.9452 52.8751L42.4211 52.2422L40.9321 52.8751Z",
    fill: "#FFE4D4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5585 56.1244L46.0817 55.4313L44.4818 54.7515L42.958 55.4313L44.5585 56.1244Z",
    fill: "#FFE4D4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4606 54.367L45.9483 53.7068L44.3877 53.0588L42.8992 53.7068L44.4606 54.367Z",
    fill: "#FFE4D4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9699 62.7981L27.8215 63.7394L28.862 63.2661L27.9699 62.7981Z",
    fill: "#FFE4D4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9653 58.1828L42.6074 58.9299L44.208 58.1828L42.5663 57.4502L40.9653 58.1828Z",
    fill: "#FFE4D4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6614 57.971L46.2217 57.2425L44.5809 56.5281L43.0198 57.2425L44.6614 57.971Z",
    fill: "#FFE4D4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9536 56.3257L42.5546 57.0361L44.116 56.3257L42.5154 55.6289L40.9536 56.3257Z",
    fill: "#FFE4D4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2053 60.3606L34.4756 61.152L36.1162 61.96L37.8469 61.152L36.2053 60.3606Z",
    fill: "#FFE4D4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1134 45.5244L38.7801 45.0178L37.4187 45.5244L38.7517 46.0396L40.1134 45.5244Z",
    fill: "#FFE4D4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8948 46.8675L42.2861 47.4053L43.6477 46.8675L42.2565 46.3389L40.8948 46.8675Z",
    fill: "#FFE4D4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3569 46.1888L37.0241 45.6714L35.6335 46.1888L36.9659 46.7151L38.3569 46.1888Z",
    fill: "#FFE4D4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8145 61.152L40.5001 61.96L42.1857 61.152L40.5001 60.3606L38.8145 61.152Z",
    fill: "#FFE4D4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9036 48.2702L42.326 48.8319L43.717 48.2702L42.2949 47.718L40.9036 48.2702Z",
    fill: "#FFE4D4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M44.112 48.1108L45.4728 47.5613L44.0512 47.021L42.6899 47.5612L44.112 48.1108Z",
    fill: "#FFE4D4"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7697 59.9136L46.3692 59.1469L44.685 58.3955L43.0847 59.1469L44.7697 59.9136Z",
    fill: "#FFE4D4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1933 49.5691L45.5837 48.9947L44.1298 48.4302L42.7388 48.9947L44.1933 49.5691Z",
    fill: "#FFE4D4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2783 51.0948L45.6997 50.4937L44.2119 49.9033L42.7898 50.4937L44.2783 51.0948Z",
    fill: "#FFE4D4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9126 49.7357L42.3676 50.3232L43.7897 49.7357L42.3352 49.1584L40.9126 49.7357Z",
    fill: "#FFE4D4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0778 51.2692L38.6229 50.665L37.1343 51.2692L38.5888 51.8842L40.0778 51.2692Z",
    fill: "#FFE4D4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M27.744 64.2323L27.7266 64.3427H30.9152L29.3251 63.5088L27.744 64.2323Z",
    fill: "#FFE4D4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7881 49.9033L35.3003 50.4937L36.7217 51.0948L38.2102 50.4937L36.7881 49.9033Z",
    fill: "#FFE4D4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0676 52.8751L38.5788 52.2422L37.0547 52.8751L38.5433 53.5196L40.0676 52.8751Z",
    fill: "#FFE4D4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7023 51.4446L35.179 52.0628L36.6329 52.6923L38.1567 52.0628L36.7023 51.4446Z",
    fill: "#FFE4D4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M40.105 46.8675L38.7432 46.3389L37.3521 46.8675L38.7135 47.4053L40.105 46.8675Z",
    fill: "#FFE4D4"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9487 47.021L35.5271 47.5613L36.8879 48.1108L38.31 47.5612L36.9487 47.021Z",
    fill: "#FFE4D4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8702 48.4302L35.4163 48.9947L36.8067 49.5691L38.2612 48.9947L36.8702 48.4302Z",
    fill: "#FFE4D4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0963 48.2702L38.705 47.718L37.2827 48.2702L38.6739 48.8319L40.0963 48.2702Z",
    fill: "#FFE4D4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0872 49.7357L38.6648 49.1584L37.2102 49.7357L38.6323 50.3232L40.0872 49.7357Z",
    fill: "#FFE4D4"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0347 58.1828L38.4338 57.4502L36.792 58.1828L38.3926 58.9299L40.0347 58.1828Z",
    fill: "#FFE4D4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6124 53.0588L35.0518 53.7068L36.5394 54.367L38.1007 53.7068L36.6124 53.0588Z",
    fill: "#FFE4D4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0227 60.1365L38.3804 59.3655L36.6953 60.1365L38.3371 60.9234L40.0227 60.1365Z",
    fill: "#FFE4D4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9773 60.1365L42.6629 60.9234L44.3047 60.1365L42.6195 59.3655L40.9773 60.1365Z",
    fill: "#FFE4D4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3149 58.3955L34.6309 59.1469L36.2304 59.9136L37.9153 59.1469L36.3149 58.3955Z",
    fill: "#FFE4D4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5181 54.7515L34.9182 55.4313L36.4414 56.1244L38.0419 55.4313L36.5181 54.7515Z",
    fill: "#FFE4D4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0574 54.5587L38.5329 53.895L36.9714 54.5587L38.4956 55.235L40.0574 54.5587Z",
    fill: "#FFE4D4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4191 56.5281L34.7783 57.2425L36.3386 57.971L37.9802 57.2425L36.4191 56.5281Z",
    fill: "#FFE4D4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0463 56.3257L38.4845 55.6289L36.884 56.3257L38.4453 57.0361L40.0463 56.3257Z",
    fill: "#FFE4D4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M40.99 62.1949L42.7214 63.0246L44.4065 62.1949L42.6756 61.3821L40.99 62.1949Z",
    fill: "#FFE4D4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8383 44.5959L30.7505 45.154L31.5383 44.8737L30.8383 44.5959Z",
    fill: "#FFE4D4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0862 54.5587L34.5986 53.895L33.0002 54.5587L34.4866 55.235L36.0862 54.5587Z",
    fill: "#FFE4D4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9766 56.3257L34.4536 55.6289L32.8142 56.3257L34.336 57.0361L35.9766 56.3257Z",
    fill: "#FFE4D4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M32.536 54.7515L30.8984 55.4313L32.3831 56.1244L34.0221 55.4313L32.536 54.7515Z",
    fill: "#FFE4D4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2912 44.2502H30.893L30.8831 44.3128L31.941 44.7306L33.2912 44.2502Z",
    fill: "#FFE4D4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 51.0948L41.9549 50.4937L40.5 49.9033L39.0452 50.4937L40.5 51.0948Z",
    fill: "#FFE4D4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2898 51.2692L34.8685 50.665L33.3464 51.2692L34.7668 51.8842L36.2898 51.2692Z",
    fill: "#FFE4D4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 52.6923L41.9889 52.0628L40.4999 51.4446L39.011 52.0628L40.4999 52.6923Z",
    fill: "#FFE4D4"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7246 53.0588L31.1279 53.7068L32.5788 54.367L34.1769 53.7068L32.7246 53.0588Z",
    fill: "#FFE4D4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1902 52.8751L34.7368 52.2422L33.1772 52.8751L34.6299 53.5196L36.1902 52.8751Z",
    fill: "#FFE4D4"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9044 51.4446L31.3467 52.0628L32.7654 52.6923L34.3244 52.0628L32.9044 51.4446Z",
    fill: "#FFE4D4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9138 54.5587L46.5133 55.235L47.9997 54.5587L46.4013 53.895L44.9138 54.5587Z",
    fill: "#FFE4D4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 57.971L50.3425 57.2425L48.6618 56.5281L47.1404 57.2425L48.8226 57.971Z",
    fill: "#FFE4D4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3381 56.5281L30.6575 57.2425L32.1773 57.971L33.8594 57.2425L32.3381 56.5281Z",
    fill: "#FFE4D4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6171 56.1244L50.1017 55.4313L48.4641 54.7515L46.978 55.4313L48.6171 56.1244Z",
    fill: "#FFE4D4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0762 49.9033L31.5554 50.4937L32.9434 51.0948L34.4653 50.4937L33.0762 49.9033Z",
    fill: "#FFE4D4"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1384 58.1828L46.8223 58.9299L48.3811 58.1828L46.6986 57.4502L45.1384 58.1828Z",
    fill: "#FFE4D4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0234 56.3257L46.6641 57.0361L48.1858 56.3257L46.5463 55.6289L45.0234 56.3257Z",
    fill: "#FFE4D4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1299 58.3955L30.4038 59.1469L31.9608 59.9136L33.6884 59.1469L32.1299 58.3955Z",
    fill: "#FFE4D4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8616 58.1828L34.3015 57.4502L32.6189 58.1828L34.1778 58.9299L35.8616 58.1828Z",
    fill: "#FFE4D4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2593 60.1365L46.9887 60.9234L48.5866 60.1365L46.8585 59.3655L45.2593 60.1365Z",
    fill: "#FFE4D4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7407 60.1365L34.1415 59.3655L32.4133 60.1365L34.0113 60.9234L35.7407 60.1365Z",
    fill: "#FFE4D4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0392 59.9136L50.596 59.1469L48.8701 58.3955L47.3115 59.1469L49.0392 59.9136Z",
    fill: "#FFE4D4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 45.3782L41.8333 44.8738L40.5 44.3777L39.1667 44.8738L40.5 45.3782Z",
    fill: "#FFE4D4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4755 48.2702L35.1148 47.718L33.6619 48.2702L35.0217 48.8319L36.4755 48.2702Z",
    fill: "#FFE4D4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0344 46.7151L45.3667 46.1888L43.9761 45.6714L42.6433 46.1888L44.0344 46.7151Z",
    fill: "#FFE4D4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2406 48.4302L31.7551 48.9947L33.1137 49.5691L34.6001 48.9947L33.2406 48.4302Z",
    fill: "#FFE4D4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3973 47.021L31.9458 47.5612L33.2759 48.1108L34.7287 47.5612L33.3973 47.021Z",
    fill: "#FFE4D4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5624 46.8675L35.2301 46.3389L33.8096 46.8675L35.1409 47.4053L36.5624 46.8675Z",
    fill: "#FFE4D4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 57.971L42.1008 57.2425L40.4999 56.5281L38.8989 57.2425L40.4999 57.971Z",
    fill: "#FFE4D4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2482 46.0396L43.5812 45.5244L42.2198 45.0178L40.8865 45.5244L42.2482 46.0396Z",
    fill: "#FFE4D4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7686 63.266L40.4999 64.1185L42.2313 63.266L40.4999 62.4312L38.7686 63.266Z",
    fill: "#FFE4D4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4211 54.367L49.872 53.7068L48.2753 53.0588L46.823 53.7068L48.4211 54.367Z",
    fill: "#FFE4D4"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5001 54.367L42.0245 53.7068L40.5001 53.0588L38.9756 53.7068L40.5001 54.367Z",
    fill: "#FFE4D4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3847 49.7357L34.9943 49.1584L33.5076 49.7357L34.897 50.3232L36.3847 49.7357Z",
    fill: "#FFE4D4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1531 61.152L44.8838 61.96L46.5244 61.152L44.7947 60.3606L43.1531 61.152Z",
    fill: "#FFE4D4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 59.9136L42.1421 59.1469L40.4999 58.3955L38.8577 59.1469L40.4999 59.9136Z",
    fill: "#FFE4D4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 56.1244L42.0618 55.4313L40.5 54.7515L38.9382 55.4313L40.5 56.1244Z",
    fill: "#FFE4D4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3244 61.3821L36.5935 62.1949L38.2786 63.0246L40.01 62.1949L38.3244 61.3821Z",
    fill: "#FFE4D4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5105 49.8836L50.0798 62.9299H30.9204L32.4897 49.8836C32.622 48.7838 34.7729 48.4625 34.7729 48.4625C33.1915 47.9404 33.7575 47.0286 36.7175 46.1772C39.3439 45.4222 40.501 45.0574 40.501 45.0574C40.501 45.0574 41.6566 45.4222 44.283 46.1772C47.2444 47.0286 47.8089 47.9406 46.2292 48.4625C46.2292 48.4625 48.3782 48.7839 48.5105 49.8836Z",
    fill: "#7A2B2B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5005 45.3145C41.0173 45.4733 42.1424 45.8141 43.9669 46.3407C45.5394 46.7946 46.4824 47.2967 46.5368 47.7173C46.566 47.9421 46.3408 48.1357 45.8661 48.2919L45.1512 48.5289L46.0452 48.6685C46.1181 48.6799 47.8404 48.9591 47.9437 49.8837L49.3655 62.6026H31.6343L33.0559 49.8837C33.1592 48.9593 34.8829 48.6799 34.9525 48.669L35.8661 48.5321L35.1351 48.2919C34.66 48.1359 34.4349 47.9425 34.4637 47.7177C34.5176 47.297 35.4604 46.7949 37.0328 46.3407C38.8575 45.8141 39.9834 45.4733 40.5005 45.3145Z",
    fill: "#F29417"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M57.697 67.9516H57.3166L57.137 67.0471H57.5133L57.697 67.9516Z",
    fill: "#F29417"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5474 67.9516H58.1671L57.9783 67.0471H58.3546L58.5474 67.9516Z",
    fill: "#F29417"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8327 67.9516H22.4524L22.6452 67.0471H23.0215L22.8327 67.9516Z",
    fill: "#F29417"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6831 67.9516H23.3027L23.4864 67.0471H23.8627L23.6831 67.9516Z",
    fill: "#F29417"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5334 67.9516H24.1531L24.3278 67.0471H24.704L24.5334 67.9516Z",
    fill: "#F29417"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3837 67.9516H25.0034L25.169 67.0471H25.5452L25.3837 67.9516Z",
    fill: "#F29417"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2341 67.9516H25.8538L26.0102 67.0471H26.3864L26.2341 67.9516Z",
    fill: "#F29417"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0845 67.9516H26.7043L26.8517 67.0471H27.2279L27.0845 67.9516Z",
    fill: "#F29417"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9348 67.9516H27.5544L27.6928 67.0471H28.069L27.9348 67.9516Z",
    fill: "#F29417"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7851 67.9516H28.4048L28.5341 67.0471H28.9102L28.7851 67.9516Z",
    fill: "#F29417"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6355 67.9516H29.2554L29.3754 67.0471H29.7517L29.6355 67.9516Z",
    fill: "#F29417"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4858 67.9516H30.1055L30.2165 67.0471H30.5928L30.4858 67.9516Z",
    fill: "#F29417"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3361 67.9516H30.9558L31.0577 67.0471H31.4341L31.3361 67.9516Z",
    fill: "#F29417"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1867 67.9516H31.8064L31.8992 67.0471H32.2755L32.1867 67.9516Z",
    fill: "#F29417"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0368 67.9516H32.6565L32.7403 67.0471H33.1165L33.0368 67.9516Z",
    fill: "#F29417"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8872 67.9516H33.5068L33.5816 67.0471H33.9577L33.8872 67.9516Z",
    fill: "#F29417"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7377 67.9516H34.3574L34.423 67.0471H34.7992L34.7377 67.9516Z",
    fill: "#F29417"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5878 67.9516H35.2075L35.2642 67.0471H35.6403L35.5878 67.9516Z",
    fill: "#F29417"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4384 67.9516H36.0581L36.1056 67.0471H36.4818L36.4384 67.9516Z",
    fill: "#F29417"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2888 67.9516H36.9084L36.9468 67.0471H37.323L37.2888 67.9516Z",
    fill: "#F29417"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M38.139 67.9516H37.7588L37.7881 67.0471H38.1642L38.139 67.9516Z",
    fill: "#F29417"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9895 67.9516H38.6091L38.6293 67.0471H39.0056L38.9895 67.9516Z",
    fill: "#F29417"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8398 67.9516H39.4595L39.4705 67.0471H39.8468L39.8398 67.9516Z",
    fill: "#F29417"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M40.69 67.9516H40.3098L40.3117 67.0471H40.6881L40.69 67.9516Z",
    fill: "#F29417"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5404 67.9516H41.1601L41.1531 67.0471H41.5294L41.5404 67.9516Z",
    fill: "#F29417"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3909 67.9516H42.0105L41.9944 67.0471H42.3707L42.3909 67.9516Z",
    fill: "#F29417"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2411 67.9516H42.861L42.8357 67.0471H43.2119L43.2411 67.9516Z",
    fill: "#F29417"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0913 67.9516H43.711L43.6768 67.0471H44.0529L44.0913 67.9516Z",
    fill: "#F29417"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9417 67.9516H44.5614L44.5181 67.0471H44.8942L44.9417 67.9516Z",
    fill: "#F29417"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7922 67.9516H45.4119L45.3594 67.0471H45.7355L45.7922 67.9516Z",
    fill: "#F29417"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6424 67.9516H46.2621L46.2007 67.0471H46.5768L46.6424 67.9516Z",
    fill: "#F29417"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4929 67.9516H47.1126L47.042 67.0471H47.4182L47.4929 67.9516Z",
    fill: "#F29417"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3433 67.9516H47.963L47.8833 67.0471H48.2595L48.3433 67.9516Z",
    fill: "#F29417"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1935 67.9516H48.8132L48.7244 67.0471H49.1007L49.1935 67.9516Z",
    fill: "#F29417"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0439 67.9516H49.6636L49.5657 67.0471H49.942L50.0439 67.9516Z",
    fill: "#F29417"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8943 67.9516H50.514L50.407 67.0471H50.7831L50.8943 67.9516Z",
    fill: "#F29417"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7446 67.9516H51.3643L51.2483 67.0471H51.6246L51.7446 67.9516Z",
    fill: "#F29417"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M52.595 67.9516H52.2147L52.0896 67.0471H52.4658L52.595 67.9516Z",
    fill: "#F29417"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4455 67.9516H53.0652L52.9309 67.0471H53.3071L53.4455 67.9516Z",
    fill: "#F29417"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2955 67.9516H53.9153L53.772 67.0471H54.1481L54.2955 67.9516Z",
    fill: "#F29417"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1459 67.9516H54.7656L54.6133 67.0471H54.9894L55.1459 67.9516Z",
    fill: "#F29417"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9963 67.9516H55.616L55.4546 67.0471H55.8307L55.9963 67.9516Z",
    fill: "#F29417"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8465 67.9516H56.4664L56.2957 67.0471H56.672L56.8465 67.9516Z",
    fill: "#F29417"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5894 42.8049H52.322L52.2329 42.3564H52.4984L52.5894 42.8049Z",
    fill: "#F29417"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1871 42.8049H52.9198L52.8262 42.3564H53.0916L53.1871 42.8049Z",
    fill: "#F29417"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0803 42.8049H27.813L27.9085 42.3564H28.174L28.0803 42.8049Z",
    fill: "#F29417"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M28.678 42.8049H28.4106L28.5017 42.3564H28.7671L28.678 42.8049Z",
    fill: "#F29417"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2759 42.8049H29.0085L29.0951 42.3564H29.3605L29.2759 42.8049Z",
    fill: "#F29417"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8736 42.8049H29.6062L29.6883 42.3564H29.9536L29.8736 42.8049Z",
    fill: "#F29417"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4715 42.8049H30.2041L30.2817 42.3564H30.5471L30.4715 42.8049Z",
    fill: "#F29417"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0692 42.8049H30.802L30.875 42.3564H31.1404L31.0692 42.8049Z",
    fill: "#F29417"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M31.667 42.8049H31.3997L31.4681 42.3564H31.7334L31.667 42.8049Z",
    fill: "#F29417"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2649 42.8049H31.9976L32.0616 42.3564H32.3268L32.2649 42.8049Z",
    fill: "#F29417"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8626 42.8049H32.5952L32.6547 42.3564H32.92L32.8626 42.8049Z",
    fill: "#F29417"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4602 42.8049H33.1929L33.2479 42.3564H33.5132L33.4602 42.8049Z",
    fill: "#F29417"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0581 42.8049H33.7908L33.8413 42.3564H34.1066L34.0581 42.8049Z",
    fill: "#F29417"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6558 42.8049H34.3884L34.4345 42.3564H34.6998L34.6558 42.8049Z",
    fill: "#F29417"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2537 42.8049H34.9863L35.0279 42.3564H35.2932L35.2537 42.8049Z",
    fill: "#F29417"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8514 42.8049H35.5842L35.6212 42.3564H35.8865L35.8514 42.8049Z",
    fill: "#F29417"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4492 42.8049H36.1819L36.2144 42.3564H36.4796L36.4492 42.8049Z",
    fill: "#F29417"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0471 42.8049H36.7798L36.8078 42.3564H37.0731L37.0471 42.8049Z",
    fill: "#F29417"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6448 42.8049H37.3774L37.401 42.3564H37.6662L37.6448 42.8049Z",
    fill: "#F29417"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2427 42.8049H37.9753L37.9944 42.3564H38.2597L38.2427 42.8049Z",
    fill: "#F29417"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8404 42.8049H38.573L38.5876 42.3564H38.8528L38.8404 42.8049Z",
    fill: "#F29417"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M39.438 42.8049H39.1707L39.1807 42.3564H39.446L39.438 42.8049Z",
    fill: "#F29417"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0359 42.8049H39.7686L39.7742 42.3564H40.0394L40.0359 42.8049Z",
    fill: "#F29417"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6337 42.8049H40.3665L40.3674 42.3564H40.6327L40.6337 42.8049Z",
    fill: "#F29417"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2314 42.8049H40.9642L40.9607 42.3564H41.226L41.2314 42.8049Z",
    fill: "#F29417"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8293 42.8049H41.562L41.554 42.3564H41.8192L41.8293 42.8049Z",
    fill: "#F29417"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4271 42.8049H42.1597L42.1472 42.3564H42.4125L42.4271 42.8049Z",
    fill: "#F29417"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0248 42.8049H42.7574L42.7405 42.3564H43.0058L43.0248 42.8049Z",
    fill: "#F29417"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6225 42.8049H43.3552L43.3337 42.3564H43.599L43.6225 42.8049Z",
    fill: "#F29417"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2203 42.8049H43.9529L43.927 42.3564H44.1923L44.2203 42.8049Z",
    fill: "#F29417"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M44.818 42.8049H44.5507L44.5203 42.3564H44.7855L44.818 42.8049Z",
    fill: "#F29417"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4158 42.8049H45.1486L45.1135 42.3564H45.3788L45.4158 42.8049Z",
    fill: "#F29417"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 42.8049H45.7466L45.707 42.3564H45.9723L46.0137 42.8049Z",
    fill: "#F29417"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6117 42.8049H46.3443L46.3003 42.3564H46.5656L46.6117 42.8049Z",
    fill: "#F29417"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2094 42.8049H46.942L46.8936 42.3564H47.1588L47.2094 42.8049Z",
    fill: "#F29417"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8071 42.8049H47.5398L47.4868 42.3564H47.7521L47.8071 42.8049Z",
    fill: "#F29417"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4048 42.8049H48.1374L48.0798 42.3564H48.3453L48.4048 42.8049Z",
    fill: "#F29417"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0025 42.8049H48.7352L48.6731 42.3564H48.9385L49.0025 42.8049Z",
    fill: "#F29417"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6003 42.8049H49.3329L49.2664 42.3564H49.5318L49.6003 42.8049Z",
    fill: "#F29417"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M50.198 42.8049H49.9308L49.8596 42.3564H50.1251L50.198 42.8049Z",
    fill: "#F29417"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7959 42.8049H50.5286L50.4529 42.3564H50.7183L50.7959 42.8049Z",
    fill: "#F29417"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3939 42.8049H51.1265L51.0464 42.3564H51.3118L51.3939 42.8049Z",
    fill: "#F29417"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9916 42.8049H51.7243L51.6396 42.3564H51.9051L51.9916 42.8049Z",
    fill: "#F29417"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2483 66.1916L20.2942 66.0039H22.0259L21.984 66.1916H20.2483Z",
    fill: "#F29417"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M20.145 66.6144L20.1913 66.4248H21.9319L21.8895 66.6144H20.145Z",
    fill: "#F29417"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8052 51.6307L23.8364 51.5032H25.2645L25.2361 51.6307H23.8052Z",
    fill: "#F29417"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7351 51.9177L23.7665 51.7891H25.2007L25.1719 51.9177H23.7351Z",
    fill: "#F29417"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6643 52.207L23.696 52.0774H25.1361L25.1072 52.207H23.6643Z",
    fill: "#F29417"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M23.593 52.499L23.625 52.3682H25.0714L25.0421 52.499H23.593Z",
    fill: "#F29417"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5212 52.7932L23.5536 52.6614H25.0059L24.9764 52.7932H23.5212Z",
    fill: "#F29417"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4487 53.0902L23.4812 52.957H24.9398L24.9102 53.0902H23.4487Z",
    fill: "#F29417"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3755 53.3896L23.4083 53.2554H24.8731L24.8432 53.3896H23.3755Z",
    fill: "#F29417"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3018 53.6915L23.3347 53.5562H24.8059L24.7757 53.6915H23.3018Z",
    fill: "#F29417"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2275 53.9961L23.2608 53.8596H24.7384L24.7079 53.9961H23.2275Z",
    fill: "#F29417"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1521 54.3035L23.1859 54.1658H24.6697L24.639 54.3035H23.1521Z",
    fill: "#F29417"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0767 54.6134L23.1106 54.4744H24.601L24.5699 54.6134H23.0767Z",
    fill: "#F29417"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 54.926L23.0345 54.7859H24.5314L24.5001 54.926H23.0002Z",
    fill: "#F29417"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9231 55.2413L22.9577 55.0999H24.4612L24.4297 55.2413H22.9231Z",
    fill: "#F29417"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8455 55.5597L22.8802 55.417H24.3904L24.3586 55.5597H22.8455Z",
    fill: "#F29417"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7668 55.8807L22.802 55.7368H24.3188L24.2868 55.8807H22.7668Z",
    fill: "#F29417"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M22.688 56.2046L22.7235 56.0593H24.247L24.2145 56.2046H22.688Z",
    fill: "#F29417"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6082 56.5313L22.644 56.3848H24.1744L24.1416 56.5313H22.6082Z",
    fill: "#F29417"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5276 56.861L22.5636 56.7131H24.1009L24.0679 56.861H22.5276Z",
    fill: "#F29417"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4463 57.1938L22.4826 57.0447H24.0269L23.9935 57.1938H22.4463Z",
    fill: "#F29417"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3643 57.5295L22.4011 57.3789H23.9523L23.9187 57.5295H22.3643Z",
    fill: "#F29417"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2815 57.8681L22.3186 57.7163H23.8769L23.8429 57.8681H22.2815Z",
    fill: "#F29417"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M22.198 58.2102L22.2354 58.0569H23.8009L23.7666 58.2102H22.198Z",
    fill: "#F29417"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1138 58.5554L22.1515 58.4006H23.7242L23.6896 58.5554H22.1138Z",
    fill: "#F29417"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0286 58.9036L22.0668 58.7476H23.6466L23.6118 58.9036H22.0286Z",
    fill: "#F29417"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9429 59.255L21.9813 59.0974H23.5685L23.5333 59.255H21.9429Z",
    fill: "#F29417"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M21.856 59.6097L21.8948 59.4507H23.4894L23.4539 59.6097H21.856Z",
    fill: "#F29417"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7686 59.968L21.8078 59.8074H23.4098L23.374 59.968H21.7686Z",
    fill: "#F29417"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 60.3293L21.7199 60.1672H23.3295L23.2931 60.3293H21.6802Z",
    fill: "#F29417"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5911 60.6944L21.6311 60.5308H23.2482L23.2117 60.6944H21.5911Z",
    fill: "#F29417"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5012 61.0627L21.5415 60.8975H23.1663L23.1295 61.0627H21.5012Z",
    fill: "#F29417"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4104 61.4345L21.4512 61.2678H23.0838L23.0466 61.4345H21.4104Z",
    fill: "#F29417"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3186 61.8099L21.3597 61.6416H23.0002L22.9626 61.8099H21.3186Z",
    fill: "#F29417"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2261 62.189L21.2677 62.019H22.916L22.8781 62.189H21.2261Z",
    fill: "#F29417"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1326 62.5721L21.1745 62.4004H22.8308L22.7924 62.5721H21.1326Z",
    fill: "#F29417"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0381 62.9584L21.0805 62.7852H22.745L22.7062 62.9584H21.0381Z",
    fill: "#F29417"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9429 63.3489L20.9856 63.1738H22.6581L22.619 63.3489H20.9429Z",
    fill: "#F29417"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8464 63.7427L20.8896 63.5659H22.5703L22.5309 63.7427H20.8464Z",
    fill: "#F29417"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7493 64.141L20.7929 63.9624H22.4819L22.4421 64.141H20.7493Z",
    fill: "#F29417"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6509 64.543L20.695 64.3628H22.3923L22.3522 64.543H20.6509Z",
    fill: "#F29417"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M20.552 64.9489L20.5965 64.7668H22.3022L22.2616 64.9489H20.552Z",
    fill: "#F29417"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4517 65.359L20.4966 65.175H22.211L22.1701 65.359H20.4517Z",
    fill: "#F29417"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3503 65.7732L20.3958 65.5874H22.1188L22.0772 65.7732H20.3503Z",
    fill: "#F29417"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8748 51.346L23.9056 51.2195H25.3279L25.2996 51.346H23.8748Z",
    fill: "#F29417"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8833 43.1231L25.9071 43.0254H27.1579L27.1361 43.1231H25.8833Z",
    fill: "#F29417"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 43.3429L25.8537 43.2444H27.109L27.087 43.3429H25.8296Z",
    fill: "#F29417"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7756 43.5647L25.8 43.4653H27.0598L27.0376 43.5647H25.7756Z",
    fill: "#F29417"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7209 43.7877L25.7454 43.6877H27.0101L26.9877 43.7877H25.7209Z",
    fill: "#F29417"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6663 44.0125L25.6909 43.9119H26.9602L26.9376 44.0125H25.6663Z",
    fill: "#F29417"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6108 44.239L25.6356 44.1375H26.9097L26.887 44.239H25.6108Z",
    fill: "#F29417"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5552 44.4672L25.5801 44.365H26.8589L26.8361 44.4672H25.5552Z",
    fill: "#F29417"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M25.499 44.697L25.5241 44.594H26.8077L26.7848 44.697H25.499Z",
    fill: "#F29417"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4424 44.9285L25.4677 44.8247H26.756L26.7328 44.9285H25.4424Z",
    fill: "#F29417"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3853 45.162L25.4109 45.0574H26.7041L26.6808 45.162H25.3853Z",
    fill: "#F29417"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3279 45.397L25.3536 45.2917H26.6517L26.6282 45.397H25.3279Z",
    fill: "#F29417"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M25.27 45.6339L25.2961 45.5278H26.5991L26.5755 45.6339H25.27Z",
    fill: "#F29417"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2117 45.8729L25.2377 45.7659H26.5459L26.5219 45.8729H25.2117Z",
    fill: "#F29417"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1531 46.1135L25.1793 46.0056H26.4924L26.4683 46.1135H25.1531Z",
    fill: "#F29417"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0938 46.3557L25.1201 46.2471H26.4384L26.4141 46.3557H25.0938Z",
    fill: "#F29417"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0339 46.6002L25.0608 46.4907H26.384L26.3595 46.6002H25.0339Z",
    fill: "#F29417"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9739 46.8463L25.0009 46.7361H26.3292L26.3046 46.8463H24.9739Z",
    fill: "#F29417"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9133 47.0946L24.9404 46.9834H26.274L26.2492 47.0946H24.9133Z",
    fill: "#F29417"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8523 47.3447L24.8797 47.2327H26.2184L26.1934 47.3447H24.8523Z",
    fill: "#F29417"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7905 47.5969L24.8182 47.4839H26.1622L26.1369 47.5969H24.7905Z",
    fill: "#F29417"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7285 47.8507L24.7564 47.7368H26.1056L26.0802 47.8507H24.7285Z",
    fill: "#F29417"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 48.1069L24.694 47.9922H26.0487L26.0231 48.1069H24.666Z",
    fill: "#F29417"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M24.603 48.3649L24.6313 48.2493H25.9913L25.9656 48.3649H24.603Z",
    fill: "#F29417"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5393 48.6252L24.5678 48.5085H25.9332L25.9071 48.6252H24.5393Z",
    fill: "#F29417"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4753 48.8874L24.5041 48.7698H25.875L25.8488 48.8874H24.4753Z",
    fill: "#F29417"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4109 49.1518L24.4398 49.0332H25.8163L25.7898 49.1518H24.4109Z",
    fill: "#F29417"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3457 49.4183L24.3748 49.2988H25.7569L25.7302 49.4183H24.3457Z",
    fill: "#F29417"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M24.28 49.6869L24.3095 49.5664H25.697L25.6701 49.6869H24.28Z",
    fill: "#F29417"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2139 49.9579L24.2435 49.8364H25.6369L25.6097 49.9579H24.2139Z",
    fill: "#F29417"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1472 50.231L24.1771 50.1086H25.5762L25.5488 50.231H24.1472Z",
    fill: "#F29417"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0798 50.5062L24.1099 50.3828H25.5147L25.4872 50.5062H24.0798Z",
    fill: "#F29417"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 50.7839L24.0424 50.6594H25.4529L25.4251 50.7839H24.012Z",
    fill: "#F29417"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9438 51.0637L23.9744 50.9382H25.3907L25.3627 51.0637H23.9438Z",
    fill: "#F29417"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0168 66.1916L58.9749 66.0039H60.7067L60.7525 66.1916H59.0168Z",
    fill: "#F29417"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1111 66.6144L59.0688 66.4248H60.8093L60.8557 66.6144H59.1111Z",
    fill: "#F29417"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7647 51.6307L55.7361 51.5032H57.1644L57.1954 51.6307H55.7647Z",
    fill: "#F29417"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8287 51.9177L55.8 51.7891H57.2341L57.2656 51.9177H55.8287Z",
    fill: "#F29417"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8932 52.207L55.8643 52.0774H57.3044L57.3363 52.207H55.8932Z",
    fill: "#F29417"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9585 52.499L55.9292 52.3682H57.3754L57.4074 52.499H55.9585Z",
    fill: "#F29417"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0242 52.7932L55.9946 52.6614H57.4471L57.4794 52.7932H56.0242Z",
    fill: "#F29417"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0906 53.0902L56.0608 52.957H57.5195L57.552 53.0902H56.0906Z",
    fill: "#F29417"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1574 53.3896L56.1274 53.2554H57.5922L57.625 53.3896H56.1574Z",
    fill: "#F29417"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2247 53.6915L56.1946 53.5562H57.6656L57.6987 53.6915H56.2247Z",
    fill: "#F29417"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M56.293 53.9961L56.2625 53.8596H57.74L57.7733 53.9961H56.293Z",
    fill: "#F29417"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3617 54.3035L56.3308 54.1658H57.8148L57.8484 54.3035H56.3617Z",
    fill: "#F29417"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4307 54.6134L56.3997 54.4744H57.8901L57.924 54.6134H56.4307Z",
    fill: "#F29417"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5006 54.926L56.4692 54.7859H57.9662L58.0004 54.926H56.5006Z",
    fill: "#F29417"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5711 55.2413L56.5396 55.0999H58.0429L58.0775 55.2413H56.5711Z",
    fill: "#F29417"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6419 55.5597L56.6101 55.417H58.1202L58.1551 55.5597H56.6419Z",
    fill: "#F29417"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7138 55.8807L56.6816 55.7368H58.1986L58.2336 55.8807H56.7138Z",
    fill: "#F29417"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M56.786 56.2046L56.7537 56.0593H58.2772L58.3127 56.2046H56.786Z",
    fill: "#F29417"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8592 56.5313L56.8264 56.3848H58.3568L58.3927 56.5313H56.8592Z",
    fill: "#F29417"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9329 56.861L56.8999 56.7131H58.4372L58.4732 56.861H56.9329Z",
    fill: "#F29417"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0069 57.1938L56.9736 57.0447H58.5178L58.5543 57.1938H57.0069Z",
    fill: "#F29417"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0819 57.5295L57.0483 57.3789H58.5995L58.6363 57.5295H57.0819Z",
    fill: "#F29417"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1577 57.8681L57.1238 57.7163H58.682L58.7191 57.8681H57.1577Z",
    fill: "#F29417"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M57.234 58.2102L57.1997 58.0569H58.7651L58.8026 58.2102H57.234Z",
    fill: "#F29417"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3112 58.5554L57.2766 58.4006H58.8493L58.887 58.5554H57.3112Z",
    fill: "#F29417"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3889 58.9036L57.354 58.7476H58.9338L58.9721 58.9036H57.3889Z",
    fill: "#F29417"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4676 59.255L57.4324 59.0974H59.0196L59.058 59.255H57.4676Z",
    fill: "#F29417"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5467 59.6097L57.5112 59.4507H59.1058L59.1447 59.6097H57.5467Z",
    fill: "#F29417"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6267 59.968L57.5908 59.8074H59.1929L59.2321 59.968H57.6267Z",
    fill: "#F29417"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7075 60.3293L57.6711 60.1672H59.2807L59.3204 60.3293H57.7075Z",
    fill: "#F29417"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7889 60.6944L57.7524 60.5308H59.3696L59.4096 60.6944H57.7889Z",
    fill: "#F29417"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8713 61.0627L57.8345 60.8975H59.4593L59.4996 61.0627H57.8713Z",
    fill: "#F29417"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9541 61.4345L57.917 61.2678H59.5496L59.5903 61.4345H57.9541Z",
    fill: "#F29417"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0383 61.8099L58.0007 61.6416H59.6411L59.6822 61.8099H58.0383Z",
    fill: "#F29417"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1228 62.189L58.0847 62.019H59.7332L59.7746 62.189H58.1228Z",
    fill: "#F29417"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2084 62.5721L58.1702 62.4004H59.8265L59.8684 62.5721H58.2084Z",
    fill: "#F29417"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2946 62.9584L58.2559 62.7852H59.9202L59.9626 62.9584H58.2946Z",
    fill: "#F29417"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M58.382 63.3489L58.3428 63.1738H60.0153L60.0581 63.3489H58.382Z",
    fill: "#F29417"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4699 63.7427L58.4304 63.5659H60.1112L60.1543 63.7427H58.4699Z",
    fill: "#F29417"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5586 64.141L58.5188 63.9624H60.2079L60.2514 64.141H58.5586Z",
    fill: "#F29417"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6487 64.543L58.6084 64.3628H60.3058L60.3498 64.543H58.6487Z",
    fill: "#F29417"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7391 64.9489L58.6985 64.7668H60.4044L60.4489 64.9489H58.7391Z",
    fill: "#F29417"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8309 65.359L58.7898 65.175H60.5042L60.5492 65.359H58.8309Z",
    fill: "#F29417"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9233 65.7732L58.8818 65.5874H60.6049L60.6502 65.7732H58.9233Z",
    fill: "#F29417"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M55.701 51.346L55.6729 51.2195H57.0951L57.126 51.346H55.701Z",
    fill: "#F29417"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8643 43.1231L53.8425 43.0254H55.0933L55.1171 43.1231H53.8643Z",
    fill: "#F29417"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9135 43.3429L53.8916 43.2444H55.1468L55.171 43.3429H53.9135Z",
    fill: "#F29417"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9629 43.5647L53.9407 43.4653H55.2005L55.2248 43.5647H53.9629Z",
    fill: "#F29417"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0129 43.7877L53.9905 43.6877H55.2551L55.2796 43.7877H54.0129Z",
    fill: "#F29417"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0631 44.0125L54.0405 43.9119H55.3098L55.3344 44.0125H54.0631Z",
    fill: "#F29417"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1135 44.239L54.0908 44.1375H55.3649L55.3897 44.239H54.1135Z",
    fill: "#F29417"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1647 44.4672L54.1418 44.365H55.4206L55.4455 44.4672H54.1647Z",
    fill: "#F29417"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2158 44.697L54.1929 44.594H55.4764L55.5015 44.697H54.2158Z",
    fill: "#F29417"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2676 44.9285L54.2444 44.8247H55.5327L55.5581 44.9285H54.2676Z",
    fill: "#F29417"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3197 45.162L54.2964 45.0574H55.5895L55.6151 45.162H54.3197Z",
    fill: "#F29417"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3724 45.397L54.3489 45.2917H55.647L55.6727 45.397H54.3724Z",
    fill: "#F29417"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4252 45.6339L54.4014 45.5278H55.7046L55.7305 45.6339H54.4252Z",
    fill: "#F29417"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4786 45.8729L54.4546 45.7659H55.7627L55.7888 45.8729H54.4786Z",
    fill: "#F29417"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5322 46.1135L54.5081 46.0056H55.8212L55.8476 46.1135H54.5322Z",
    fill: "#F29417"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5863 46.3557L54.562 46.2471H55.8803L55.9068 46.3557H54.5863Z",
    fill: "#F29417"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6409 46.6002L54.6165 46.4907H55.9398L55.9665 46.6002H54.6409Z",
    fill: "#F29417"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M54.696 46.8463L54.6714 46.7361H55.9997L56.0267 46.8463H54.696Z",
    fill: "#F29417"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7514 47.0946L54.7266 46.9834H56.0602L56.0874 47.0946H54.7514Z",
    fill: "#F29417"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8073 47.3447L54.7822 47.2327H56.1209L56.1483 47.3447H54.8073Z",
    fill: "#F29417"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8635 47.5969L54.8384 47.4839H56.1824L56.2099 47.5969H54.8635Z",
    fill: "#F29417"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9202 47.8507L54.8948 47.7368H56.2441L56.2719 47.8507H54.9202Z",
    fill: "#F29417"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9775 48.1069L54.9519 47.9922H56.3066L56.3346 48.1069H54.9775Z",
    fill: "#F29417"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0352 48.3649L55.0093 48.2493H56.3694L56.3976 48.3649H55.0352Z",
    fill: "#F29417"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0932 48.6252L55.0671 48.5085H56.4326L56.4611 48.6252H55.0932Z",
    fill: "#F29417"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1517 48.8874L55.1255 48.7698H56.4964L56.5252 48.8874H55.1517Z",
    fill: "#F29417"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M55.211 49.1518L55.1846 49.0332H56.561L56.59 49.1518H55.211Z",
    fill: "#F29417"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2704 49.4183L55.2437 49.2988H56.6257L56.655 49.4183H55.2704Z",
    fill: "#F29417"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3303 49.6869L55.3035 49.5664H56.6911L56.7206 49.6869H55.3303Z",
    fill: "#F29417"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3908 49.9579L55.3638 49.8364H56.7571L56.7867 49.9579H55.3908Z",
    fill: "#F29417"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4519 50.231L55.4246 50.1086H56.8234L56.8534 50.231H55.4519Z",
    fill: "#F29417"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5134 50.5062L55.4858 50.3828H56.8905L56.9207 50.5062H55.5134Z",
    fill: "#F29417"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5753 50.7839L55.5476 50.6594H56.9582L56.9884 50.7839H55.5753Z",
    fill: "#F29417"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6379 51.0637L55.6099 50.9382H57.0262L57.0569 51.0637H55.6379Z",
    fill: "#F29417"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1189 66.711H22.5271L23.1193 63.9626C26.0348 64.0263 28.2116 65.2006 28.1189 66.711Z",
    fill: "#7A2B2B"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7041 66.24H23.5554L23.8743 64.6787C25.5397 64.7154 26.7713 65.3875 26.7041 66.24Z",
    fill: "#F29417"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2046 63.5661L23.6468 61.5131C23.7198 61.1742 24.4598 60.9142 25.1131 61.0184C25.4407 61.0705 25.7089 61.2057 25.7492 61.5011C25.8433 62.1891 23.2046 63.5661 23.2046 63.5661Z",
    fill: "#7A2B2B"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M23.356 63.6543C23.356 63.6543 25.8152 61.9082 26.5718 62.4815C27.1867 62.9474 23.356 63.6543 23.356 63.6543Z",
    fill: "#7A2B2B"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3999 63.7955C23.3999 63.7955 27.3719 62.9206 27.2879 63.6471C27.2194 64.2395 23.3999 63.7955 23.3999 63.7955Z",
    fill: "#7A2B2B"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9397 66.711H33.4162C34.1779 66.711 34.7922 66.3391 34.5831 65.9759C34.4791 65.7953 34.1891 65.639 33.5383 65.5881C32.0442 65.4711 28.9397 66.711 28.9397 66.711Z",
    fill: "#7A2B2B"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7649 66.6214C28.7649 66.6214 32.651 65.5134 31.4575 65.0667C30.5095 64.7118 28.7649 66.6214 28.7649 66.6214Z",
    fill: "#7A2B2B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4727 66.5823C28.4727 66.5823 30.5778 64.62 29.0648 64.6021C27.8516 64.5877 28.4727 66.5823 28.4727 66.5823Z",
    fill: "#7A2B2B"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8544 66.711H58.4461L57.8549 63.9626C54.9393 64.0263 52.7622 65.2006 52.8544 66.711Z",
    fill: "#7A2B2B"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2692 66.24H57.4178L57.0994 64.6787C55.434 64.7154 54.2023 65.3875 54.2692 66.24Z",
    fill: "#F29417"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7694 63.5661L57.3278 61.5131C57.2548 61.1742 56.515 60.9142 55.8617 61.0184C55.534 61.0705 55.2658 61.2057 55.2254 61.5011C55.1311 62.1891 57.7694 63.5661 57.7694 63.5661Z",
    fill: "#7A2B2B"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6179 63.6543C57.6179 63.6543 55.1592 61.9082 54.4026 62.4815C53.7874 62.9474 57.6179 63.6543 57.6179 63.6543Z",
    fill: "#7A2B2B"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5739 63.7955C57.5739 63.7955 53.6022 62.9206 53.6859 63.6471C53.7542 64.2395 57.5739 63.7955 57.5739 63.7955Z",
    fill: "#7A2B2B"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0333 66.711H47.5568C46.7951 66.711 46.181 66.3391 46.3903 65.9759C46.4944 65.7953 46.7844 65.639 47.4352 65.5881C48.9293 65.4711 52.0333 66.711 52.0333 66.711Z",
    fill: "#7A2B2B"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M52.208 66.6214C52.208 66.6214 48.3224 65.5134 49.5158 65.0667C50.4641 64.7118 52.208 66.6214 52.208 66.6214Z",
    fill: "#7A2B2B"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5005 66.5823C52.5005 66.5823 50.396 64.62 51.909 64.6021C53.1223 64.5877 52.5005 66.5823 52.5005 66.5823Z",
    fill: "#7A2B2B"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3401 42.9807H53.3412L53.662 44.4721C51.4356 44.4356 49.5553 43.7788 49.3401 42.9807Z",
    fill: "#7A2B2B"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4487 43.2241H52.7238L52.8956 44.0665C51.6431 44.046 50.5788 43.6772 50.4487 43.2241Z",
    fill: "#F29417"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7113 44.7024L53.982 45.9606C54.0292 46.1798 53.5101 46.3504 52.9492 46.2819C52.6687 46.2477 52.4143 46.1594 52.3009 45.9685C52.0425 45.5333 53.7113 44.7024 53.7113 44.7024Z",
    fill: "#7A2B2B"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5704 44.6506C53.5704 44.6506 52.139 45.7092 51.3956 45.3524C50.8054 45.0692 53.5704 44.6506 53.5704 44.6506Z",
    fill: "#7A2B2B"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4963 44.5687C53.4963 44.5687 50.6677 45.0855 50.5696 44.6549C50.4918 44.314 53.4963 44.5687 53.4963 44.5687Z",
    fill: "#7A2B2B"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7525 42.9807H45.5493C45.0043 42.9807 44.5962 43.1726 44.7792 43.3628C44.8714 43.4585 45.0979 43.542 45.5795 43.5692C46.6893 43.6321 48.7525 42.9807 48.7525 42.9807Z",
    fill: "#7A2B2B"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8932 43.0269C48.8932 43.0269 46.2387 43.6096 47.1772 43.8523C47.9355 44.0485 48.8932 43.0269 48.8932 43.0269Z",
    fill: "#7A2B2B"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1097 43.0469C49.1097 43.0469 47.8993 44.0995 49.0339 44.1096C49.9443 44.1176 49.1097 43.0469 49.1097 43.0469Z",
    fill: "#7A2B2B"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6408 42.9807H27.6396L27.3184 44.4721C29.5448 44.4356 31.4252 43.7788 31.6408 42.9807Z",
    fill: "#7A2B2B"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5318 43.2241H28.2567L28.0847 44.0665C29.337 44.046 30.4015 43.6772 30.5318 43.2241Z",
    fill: "#F29417"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2687 44.7024L26.9976 45.9606C26.9504 46.1798 27.4693 46.3504 28.0303 46.2819C28.3106 46.2477 28.5651 46.1594 28.6787 45.9685C28.9373 45.5333 27.2687 44.7024 27.2687 44.7024Z",
    fill: "#7A2B2B"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4099 44.6506C27.4099 44.6506 28.841 45.7092 29.5843 45.3524C30.1746 45.0692 27.4099 44.6506 27.4099 44.6506Z",
    fill: "#7A2B2B"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4839 44.5687C27.4839 44.5687 30.3124 45.0855 30.4106 44.6549C30.4885 44.314 27.4839 44.5687 27.4839 44.5687Z",
    fill: "#7A2B2B"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2283 42.9807H35.4315C35.9764 42.9807 36.3846 43.1726 36.2014 43.3628C36.1092 43.4585 35.8827 43.542 35.4011 43.5692C34.2913 43.6321 32.2283 42.9807 32.2283 42.9807Z",
    fill: "#7A2B2B"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0876 43.0269C32.0876 43.0269 34.742 43.6096 33.8033 43.8523C33.0451 44.0485 32.0876 43.0269 32.0876 43.0269Z",
    fill: "#7A2B2B"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8711 43.0469C31.8711 43.0469 33.0812 44.0995 31.9467 44.1096C31.0363 44.1176 31.8711 43.0469 31.8711 43.0469Z",
    fill: "#7A2B2B"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 68.1343H20.1976C20.1512 68.3285 20.3203 68.4965 20.6059 68.5861L19.6755 71.0916H21.3771L21.5866 68.5861C21.9127 68.4965 22.1583 68.3285 22.2002 68.1343Z",
    fill: "#7A2B2B"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1696 68.1343H23.167C23.1273 68.3285 23.3024 68.4965 23.591 68.5861L22.7483 71.0916H24.4497L24.5715 68.5861C24.8947 68.4965 25.1344 68.3285 25.1696 68.1343Z",
    fill: "#7A2B2B"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1388 68.1343H26.1362C26.1033 68.3285 26.2844 68.4965 26.5761 68.5861L25.821 71.0916H27.5226L27.5567 68.5861C27.8767 68.4965 28.1106 68.3285 28.1388 68.1343Z",
    fill: "#7A2B2B"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1083 68.1343H29.1057C29.0796 68.3285 29.2665 68.4965 29.5614 68.5861L28.894 71.0916H30.5956L30.542 68.5861C30.8588 68.4965 31.0868 68.3285 31.1083 68.1343Z",
    fill: "#7A2B2B"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0778 68.1343H32.0752C32.0558 68.3285 32.2486 68.4965 32.5467 68.5861L31.967 71.0916H33.6686L33.5274 68.5861C33.841 68.4965 34.063 68.3285 34.0778 68.1343Z",
    fill: "#7A2B2B"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0472 68.1343H35.0444C35.032 68.3285 35.2305 68.4965 35.5318 68.5861L35.0398 71.0916H36.7414L36.5124 68.5861C36.823 68.4965 37.0393 68.3285 37.0472 68.1343Z",
    fill: "#7A2B2B"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0166 68.1343H38.014C38.0083 68.3285 38.2129 68.4965 38.5172 68.5861L38.1129 71.0916H39.8145L39.4979 68.5861C39.8051 68.4965 40.0155 68.3285 40.0166 68.1343Z",
    fill: "#7A2B2B"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9862 68.1343H40.9836C40.9848 68.3285 41.1952 68.4965 41.5025 68.5861L41.1859 71.0916H42.8875L42.4832 68.5861C42.7873 68.4965 42.9918 68.3285 42.9862 68.1343Z",
    fill: "#7A2B2B"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9554 68.1343H43.9529C43.9607 68.3285 44.177 68.4965 44.4876 68.5861L44.2586 71.0916H45.9602L45.4682 68.5861C45.7694 68.4965 45.9679 68.3285 45.9554 68.1343Z",
    fill: "#7A2B2B"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9249 68.1343H46.9224C46.9371 68.3285 47.1592 68.4965 47.4729 68.5861L47.3316 71.0916H49.0331L48.4534 68.5861C48.7515 68.4965 48.9443 68.3285 48.9249 68.1343Z",
    fill: "#7A2B2B"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8942 68.1343H49.8916C49.913 68.3285 50.141 68.4965 50.458 68.5861L50.4044 71.0916H52.106L51.4386 68.5861C51.7334 68.4965 51.9202 68.3285 51.8942 68.1343Z",
    fill: "#7A2B2B"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8636 68.1343H52.8611C52.8894 68.3285 53.1233 68.4965 53.4433 68.5861L53.4774 71.0916H55.179L54.424 68.5861C54.7155 68.4965 54.8964 68.3285 54.8636 68.1343Z",
    fill: "#7A2B2B"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8331 68.1343H55.8306C55.8656 68.3285 56.1054 68.4965 56.4286 68.5861L56.5504 71.0916H58.2518L57.4091 68.5861C57.6976 68.4965 57.8728 68.3285 57.8331 68.1343Z",
    fill: "#7A2B2B"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8025 68.1343H58.7998C58.8417 68.3285 59.0873 68.4965 59.4136 68.5861L59.623 71.0916H61.3246L60.394 68.5861C60.6796 68.4965 60.8489 68.3285 60.8025 68.1343Z",
    fill: "#7A2B2B"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M53.221 42.268H54.6132C54.5908 42.1745 54.4271 42.0942 54.2057 42.0517L54.1686 40.9187H53.0518L53.5302 42.0517C53.3281 42.0942 53.2009 42.1745 53.221 42.268Z",
    fill: "#7A2B2B"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M51.157 42.268H52.5492C52.5301 42.1745 52.3692 42.0942 52.1492 42.0517L52.1517 40.9187H51.0349L51.4736 42.0517C51.2701 42.0942 51.14 42.1745 51.157 42.268Z",
    fill: "#7A2B2B"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0928 42.268H50.4849C50.4691 42.1745 50.311 42.0942 50.0926 42.0517L50.1349 40.9187H49.0181L49.4171 42.0517C49.212 42.0942 49.0792 42.1745 49.0928 42.268Z",
    fill: "#7A2B2B"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0285 42.268H48.4207C48.4082 42.1745 48.2528 42.0942 48.0359 42.0517L48.1178 40.9187H47.001L47.3603 42.0517C47.1538 42.0942 47.0181 42.1745 47.0285 42.268Z",
    fill: "#7A2B2B"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9644 42.268H46.3565C46.3472 42.1745 46.1948 42.0942 45.9792 42.0517L46.1008 40.9187H44.984L45.3039 42.0517C45.0957 42.0942 44.9573 42.1745 44.9644 42.268Z",
    fill: "#7A2B2B"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9002 42.268H44.2924C44.2863 42.1745 44.1367 42.0942 43.9228 42.0517L44.0839 40.9187H42.9671L43.2473 42.0517C43.0377 42.0942 42.8964 42.1745 42.9002 42.268Z",
    fill: "#7A2B2B"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8362 42.268H42.2283C42.2256 42.1745 42.0787 42.0942 41.8663 42.0517L42.0671 40.9187H40.9503L41.1907 42.0517C40.9797 42.0942 40.8357 42.1745 40.8362 42.268Z",
    fill: "#7A2B2B"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M38.772 42.268H40.1641C40.1646 42.1745 40.0206 42.0942 39.8096 42.0517L40.0501 40.9187H38.9333L39.1341 42.0517C38.9216 42.0942 38.7747 42.1745 38.772 42.268Z",
    fill: "#7A2B2B"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7078 42.268H38.0999C38.1038 42.1745 37.9625 42.0942 37.753 42.0517L38.0332 40.9187H36.9164L37.0775 42.0517C36.8634 42.0942 36.7138 42.1745 36.7078 42.268Z",
    fill: "#7A2B2B"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6436 42.268H36.0357C36.0428 42.1745 35.9044 42.0942 35.6964 42.0517L36.0162 40.9187H34.8994L35.021 42.0517C34.8053 42.0942 34.6528 42.1745 34.6436 42.268Z",
    fill: "#7A2B2B"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5793 42.268H33.9715C33.9819 42.1745 33.8462 42.0942 33.6397 42.0517L33.999 40.9187H32.8822L32.9641 42.0517C32.7473 42.0942 32.592 42.1745 32.5793 42.268Z",
    fill: "#7A2B2B"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5154 42.268H31.9075C31.9211 42.1745 31.7883 42.0942 31.5834 42.0517L31.9824 40.9187H30.8656L30.9079 42.0517C30.6893 42.0942 30.5312 42.1745 30.5154 42.268Z",
    fill: "#7A2B2B"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4512 42.268H29.8433C29.8603 42.1745 29.7302 42.0942 29.5267 42.0517L29.9654 40.9187H28.8486L28.8512 42.0517C28.6313 42.0942 28.4704 42.1745 28.4512 42.268Z",
    fill: "#7A2B2B"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M26.387 42.268H27.7791C27.7993 42.1745 27.6721 42.0942 27.47 42.0517L27.9484 40.9187H26.8316L26.7945 42.0517C26.5732 42.0942 26.4094 42.1745 26.387 42.268Z",
    fill: "#7A2B2B"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3254 47.9086L26.7356 47.2326L28.5774 46.5706L30.1698 47.2326L28.3254 47.9086Z",
    fill: "#7A2B2B"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3764 47.638L27.4185 47.2325L28.5281 46.832L29.4869 47.2325L28.3764 47.638Z",
    fill: "#FFE4D4"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4186 47.4132L27.9907 47.2327L28.4864 47.0532L28.9146 47.2327L28.4186 47.4132Z",
    fill: "#F29417"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9174 50.0742L26.2793 49.3524L28.1865 48.646L29.8275 49.3524L27.9174 50.0742Z",
    fill: "#7A2B2B"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9717 49.7852L26.9846 49.3524L28.1337 48.925L29.1217 49.3524L27.9717 49.7852Z",
    fill: "#FFE4D4"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0171 49.5448L27.5762 49.3523L28.0896 49.1606L28.5307 49.3523L28.0171 49.5448Z",
    fill: "#F29417"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M27.481 52.3897L25.7917 51.6173L27.7689 50.8618L29.4615 51.6173L27.481 52.3897Z",
    fill: "#7A2B2B"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5392 52.0805L26.5212 51.6173L27.7126 51.1602L28.7318 51.6173L27.5392 52.0805Z",
    fill: "#FFE4D4"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5878 51.8234L27.1331 51.6173L27.6652 51.4124L28.1203 51.6173L27.5878 51.8234Z",
    fill: "#F29417"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0135 54.8718L25.2695 54.0432L27.3222 53.2334L29.0697 54.0432L27.0135 54.8718Z",
    fill: "#7A2B2B"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M27.076 54.5399L26.0251 54.0431L27.2618 53.5532L28.3139 54.0431L27.076 54.5399Z",
    fill: "#FFE4D4"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1279 54.2641L26.6584 54.0432L27.2109 53.8235L27.6807 54.0432L27.1279 54.2641Z",
    fill: "#F29417"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5108 57.5385L24.7087 56.6473L26.8427 55.7773L28.6487 56.6473L26.5108 57.5385Z",
    fill: "#7A2B2B"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5781 57.1812L25.4922 56.6472L26.7779 56.1206L27.8653 56.6472L26.5781 57.1812Z",
    fill: "#FFE4D4"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M26.634 56.8849L26.1489 56.6473L26.7233 56.4111L27.2088 56.6473L26.634 56.8849Z",
    fill: "#F29417"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9696 60.4117L24.1055 59.4507L26.3274 58.5134L28.196 59.4507L25.9696 60.4117Z",
    fill: "#7A2B2B"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0422 60.0267L24.9187 59.4507L26.2576 58.8833L27.3825 59.4507L26.0422 60.0267Z",
    fill: "#FFE4D4"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1025 59.7069L25.6006 59.4507L26.1987 59.1963L26.7009 59.4507L26.1025 59.7069Z",
    fill: "#F29417"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6723 48.2752C28.6556 48.3664 28.4555 48.4403 28.2251 48.4403C27.9947 48.4403 27.8224 48.3662 27.8401 48.2752C27.8579 48.1843 28.058 48.1108 28.2872 48.1108C28.5164 48.1108 28.6889 48.1843 28.6723 48.2752Z",
    fill: "#FFE4D4"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2736 50.4655C28.2558 50.5628 28.0483 50.642 27.8102 50.642C27.572 50.642 27.3944 50.5628 27.4132 50.4655C27.4321 50.3684 27.6395 50.2898 27.8764 50.2898C28.1136 50.29 28.2913 50.3684 28.2736 50.4655Z",
    fill: "#FFE4D4"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8473 52.8088C27.8282 52.9132 27.613 52.998 27.3665 52.998C27.1199 52.998 26.9365 52.9132 26.9569 52.8088C26.9772 52.7048 27.1922 52.6208 27.4375 52.6208C27.6828 52.6208 27.8661 52.7048 27.8473 52.8088Z",
    fill: "#FFE4D4"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3898 55.3216C27.3695 55.4336 27.1458 55.5246 26.8903 55.5246C26.6348 55.5246 26.4455 55.4336 26.4673 55.3216C26.489 55.2099 26.7126 55.1196 26.9666 55.1196C27.2206 55.1198 27.4102 55.21 27.3898 55.3216Z",
    fill: "#FFE4D4"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8982 58.0227C26.8763 58.1432 26.6435 58.2413 26.3785 58.2413C26.1134 58.2413 25.9177 58.1432 25.9411 58.0227C25.9645 57.9025 26.1971 57.8054 26.4606 57.8054C26.7241 57.8054 26.9201 57.9027 26.8982 58.0227Z",
    fill: "#FFE4D4"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6866 47.9086L50.8418 47.2326L52.4341 46.5706L54.2762 47.2326L52.6866 47.9086Z",
    fill: "#7A2B2B"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6355 47.6382L51.5247 47.2328L52.4835 46.8323L53.5933 47.2328L52.6355 47.6382Z",
    fill: "#FFE4D4"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M52.593 47.4132L52.0972 47.2327L52.5252 47.0532L53.021 47.2327L52.593 47.4132Z",
    fill: "#F29417"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0948 50.0742L51.1846 49.3524L52.8254 48.646L54.7327 49.3524L53.0948 50.0742Z",
    fill: "#7A2B2B"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0402 49.7852L51.8901 49.3524L52.8781 48.925L54.0273 49.3524L53.0402 49.7852Z",
    fill: "#FFE4D4"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M52.995 49.5448L52.4814 49.3523L52.9226 49.1606L53.436 49.3523L52.995 49.5448Z",
    fill: "#F29417"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5317 52.3897L51.551 51.6173L53.2435 50.8618L55.2209 51.6173L53.5317 52.3897Z",
    fill: "#7A2B2B"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4734 52.0805L52.2808 51.6173L53.2998 51.1602L54.4912 51.6173L53.4734 52.0805Z",
    fill: "#FFE4D4"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4251 51.8234L52.8926 51.6173L53.3475 51.4124L53.8798 51.6173L53.4251 51.8234Z",
    fill: "#F29417"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9997 54.8718L51.9434 54.0432L53.6907 53.2334L55.7434 54.0432L53.9997 54.8718Z",
    fill: "#7A2B2B"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9371 54.5399L52.699 54.0431L53.751 53.5532L54.9879 54.0431L53.9371 54.5399Z",
    fill: "#FFE4D4"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8852 54.2641L53.3323 54.0432L53.802 53.8235L54.3545 54.0432L53.8852 54.2641Z",
    fill: "#F29417"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5026 57.5385L52.3645 56.6473L54.1704 55.7773L56.3045 56.6473L54.5026 57.5385Z",
    fill: "#7A2B2B"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4352 57.1812L53.1479 56.6472L54.2352 56.1206L55.5211 56.6472L54.4352 57.1812Z",
    fill: "#FFE4D4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3794 56.8849L53.8047 56.6473L54.29 56.4111L54.8645 56.6473L54.3794 56.8849Z",
    fill: "#F29417"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0444 60.4117L52.8179 59.4507L54.6863 58.5134L56.9084 59.4507L55.0444 60.4117Z",
    fill: "#7A2B2B"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9718 60.0267L53.6313 59.4507L54.7561 58.8833L56.095 59.4507L54.9718 60.0267Z",
    fill: "#FFE4D4"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9115 59.7069L54.313 59.4507L54.8152 59.1963L55.4135 59.4507L54.9115 59.7069Z",
    fill: "#F29417"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1718 48.2752C53.1895 48.3664 53.0172 48.4403 52.7868 48.4403C52.5564 48.4403 52.3561 48.3662 52.3395 48.2752C52.323 48.1843 52.4955 48.1108 52.7246 48.1108C52.954 48.1108 53.1542 48.1843 53.1718 48.2752Z",
    fill: "#FFE4D4"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5991 50.4655C53.6181 50.5628 53.4404 50.642 53.2023 50.642C52.9641 50.642 52.7565 50.5628 52.7388 50.4655C52.721 50.3684 52.8989 50.2898 53.1359 50.2898C53.3727 50.29 53.5802 50.3684 53.5991 50.4655Z",
    fill: "#FFE4D4"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0559 52.8088C54.0762 52.9132 53.8928 52.998 53.6464 52.998C53.3999 52.998 53.1845 52.9132 53.1656 52.8088C53.1468 52.7048 53.3301 52.6208 53.5754 52.6208C53.8204 52.6208 54.0356 52.7048 54.0559 52.8088Z",
    fill: "#FFE4D4"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5459 55.3216C54.5678 55.4336 54.3784 55.5246 54.1228 55.5246C53.8673 55.5246 53.6436 55.4336 53.6233 55.3216C53.603 55.2099 53.7924 55.1196 54.0465 55.1196C54.3006 55.1196 54.5241 55.21 54.5459 55.3216Z",
    fill: "#FFE4D4"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0726 58.0227C55.0961 58.1432 54.9002 58.2413 54.6353 58.2413C54.3702 58.2413 54.1375 58.1432 54.1154 58.0227C54.0935 57.9025 54.2895 57.8054 54.553 57.8054C54.8166 57.8054 55.049 57.9027 55.0726 58.0227Z",
    fill: "#FFE4D4"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2158 65.4304C32.2158 65.4304 34.0761 64.7341 36.1705 65.1752C38.4883 65.6634 38.2781 66.7111 37.3904 66.7111C36.0739 66.7111 36.0609 65.9456 35.1377 65.5803C33.8725 65.0795 32.2158 65.4304 32.2158 65.4304Z",
    fill: "#7A2B2B"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M48.784 65.4304C48.784 65.4304 46.9237 64.7341 44.8293 65.1752C42.5116 65.6634 42.7218 66.7111 43.6095 66.7111C44.926 66.7111 44.9389 65.9456 45.8621 65.5803C47.1274 65.0795 48.784 65.4304 48.784 65.4304Z",
    fill: "#7A2B2B"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 65.267C40.4999 65.267 38.4969 65.3596 36.8318 64.543C36.8318 64.543 37.3449 65.8137 40.4999 65.8137C43.655 65.8137 44.1681 64.543 44.1681 64.543C42.503 65.3596 40.4999 65.267 40.4999 65.267Z",
    fill: "#7A2B2B"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5897 43.6717C46.5897 43.6717 45.2927 44.0536 43.6997 43.8103C41.9714 43.5464 42.0901 42.9978 42.7255 42.9978C43.6677 42.9978 43.7279 43.3962 44.4292 43.5909C45.4082 43.8628 46.5897 43.6717 46.5897 43.6717Z",
    fill: "#7A2B2B"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 43.6717C34.4102 43.6717 35.7071 44.0536 37.3001 43.8103C39.0284 43.5464 38.9097 42.9978 38.2743 42.9978C37.3321 42.9978 37.2719 43.3962 36.5706 43.5909C35.5916 43.8628 34.4102 43.6717 34.4102 43.6717Z",
    fill: "#7A2B2B"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43.7601C40.5 43.7601 41.9747 43.7099 43.248 44.1603C43.248 44.1603 42.8006 43.4661 40.5 43.4661C38.1993 43.4661 37.752 44.1603 37.752 44.1603C39.0252 43.7099 40.5 43.7601 40.5 43.7601Z",
    fill: "#7A2B2B"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4721 45.5076C30.4721 45.5076 28.7049 46.086 30.2991 46.5812L30.4721 45.5076Z",
    fill: "#7A2B2B"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5078 45.5076C50.5078 45.5076 52.2748 46.086 50.6804 46.5812L50.5078 45.5076Z",
    fill: "#7A2B2B"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7794 62.2148C27.7794 62.2148 25.8466 61.3034 28.0474 60.5522L27.7794 62.2148Z",
    fill: "#7A2B2B"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1953 62.2148C53.1953 62.2148 55.1285 61.3034 52.928 60.5522L53.1953 62.2148Z",
    fill: "#7A2B2B"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.4998 48.9233V51.6481L34.49 51.6483L35.2724 49.1533L40.4998 48.9233Z",
    fill: "#F29417"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.4998 48.9233V51.6481L46.5095 51.6483L45.7271 49.1533L40.4998 48.9233Z",
    fill: "#F29417"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2141 49.2459C39.2141 49.2459 39.625 49.2908 39.9452 49.1776C40.3346 49.0398 40.4999 48.8904 40.4999 48.8904V48.5918L39.2141 49.2459Z",
    fill: "#A3531D"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7855 49.2459C41.7855 49.2459 41.3748 49.2908 41.0545 49.1776C40.665 49.0398 40.4998 48.8904 40.4998 48.8904V48.5918L41.7855 49.2459Z",
    fill: "#A3531D"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9946 44.5648L35.7087 41.688L40.4997 43.8769V47.58L33.9946 44.5648Z",
    fill: "#DD884E"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0049 44.5648L45.2908 41.688L40.4998 43.8769V47.58L47.0049 44.5648Z",
    fill: "#DD884E"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7739 49.173L35.1043 49.6893C35.1043 49.6893 35.8462 49.4176 36.1531 49.4474V48.7431C36.1531 48.7431 35.605 48.7332 35.5554 48.7332C35.5058 48.7332 34.7739 49.173 34.7739 49.173Z",
    fill: "#B46023"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 48.5918L34.4903 51.6482L34.1599 51.1318L39.8735 48.2739L40.4998 48.5918Z",
    fill: "#B46023"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8738 48.2741L34.1597 51.132L34.3595 50.4952C35.5753 49.8525 36.469 48.9941 35.8227 48.9311C35.516 48.9013 34.7739 49.173 34.7739 49.173L34.9083 48.745L37.8768 47.2605L39.8738 48.2741Z",
    fill: "#D47C3D"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2256 49.173L45.8952 49.6893C45.8952 49.6893 45.1533 49.4176 44.8464 49.4474V48.7431C44.8464 48.7431 45.3946 48.7332 45.4442 48.7332C45.4938 48.7332 46.2256 49.173 46.2256 49.173Z",
    fill: "#B46023"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 48.5918L46.5092 51.6482L46.8396 51.1318L41.126 48.2739L40.4998 48.5918Z",
    fill: "#B46023"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1257 48.2741L46.8398 51.132L46.6401 50.4952C45.4243 49.8525 44.5307 48.9941 45.1769 48.9311C45.4837 48.9013 46.2257 49.173 46.2257 49.173L46.0913 48.745L43.1229 47.2605L41.1257 48.2741Z",
    fill: "#D47C3D"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9947 44.5649L33.3677 44.9723L40.4998 48.592V47.5801L33.9947 44.5649Z",
    fill: "#B46023"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0049 44.5649L47.6318 44.9723L40.4998 48.592V47.5801L47.0049 44.5649Z",
    fill: "#B46023"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7088 41.688L35.0818 42.0952L33.3677 44.9721L33.9947 44.5648L35.7088 41.688Z",
    fill: "#D47C3D"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2908 41.688L45.9178 42.0952L47.6317 44.9721L47.0049 44.5648L45.2908 41.688Z",
    fill: "#D47C3D"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0558 41.5586L34.5383 44.416L40.4999 47.1578V43.6623L36.0558 41.5586Z",
    fill: "url(#paint0_linear_596_955)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 46.9713L34.718 44.3123L34.5383 44.4161L40.4999 47.1579V46.9713Z",
    fill: "#774A2B"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2354 41.4546L36.0558 41.5586L34.5383 44.416L34.718 44.3122L36.2354 41.4546Z",
    fill: "#8E5E3D"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2355 41.4546L40.4999 43.4511V46.9712L34.718 44.3122L36.2355 41.4546Z",
    fill: "#8E6E59"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 46.9713L46.2817 44.3123L46.4614 44.4161L40.4998 47.1579V46.9713Z",
    fill: "#774A2B"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7642 41.4546L44.9438 41.5586L46.4613 44.416L46.2816 44.3122L44.7642 41.4546Z",
    fill: "#8E5E3D"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7642 41.4546L40.4998 43.4511V46.9712L46.2817 44.3122L44.7642 41.4546Z",
    fill: "#8E6E59"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4532 41.4414L34.978 44.088V44.2668L40.4998 46.7638V43.3272L36.4532 41.4414Z",
    fill: "#C9C9C9"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5463 41.4414L46.0215 44.088V44.2668L40.4998 46.7638V43.3272L44.5463 41.4414Z",
    fill: "#C9C9C9"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4532 41.2627L34.978 44.088L40.4998 46.5851V43.1485L36.4532 41.2627Z",
    fill: "#DDDDDD"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5463 41.2627L46.0215 44.088L40.4998 46.5851V43.1485L44.5463 41.2627Z",
    fill: "#DDDDDD"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6948 41.165L35.2778 43.9898C35.2778 43.9898 37.1009 44.0465 40.4998 46.5785V43.1418C40.4998 43.1418 38.6954 41.2626 36.6948 41.165Z",
    fill: "#F2F2F2"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 46.5786C40.4998 46.5786 42.8433 44.6091 45.6623 44.0344L44.2354 41.2693C44.2354 41.2693 42.3626 41.3731 40.4998 43.1419V46.5786Z",
    fill: "#F2F2F2"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0743 48.2054L40.9489 48.1946L41.0116 48.1999L40.9489 48.1948C40.9498 48.1828 40.9679 47.8977 40.6601 47.7954C40.5569 47.7612 40.4431 47.7612 40.3398 47.7954C40.0292 47.8986 40.0498 48.1825 40.0508 48.1946L39.9254 48.2054C39.9137 48.0692 39.977 47.7834 40.3001 47.6761C40.4289 47.6334 40.571 47.6334 40.6998 47.6761C41.0228 47.7834 41.086 48.0694 41.0743 48.2054Z",
    fill: "#DD884E"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7139 48.1023C39.6369 48.1239 39.5667 48.2309 39.5463 48.2642C39.5425 48.2704 39.5425 48.2778 39.5463 48.284C39.5667 48.3175 39.6369 48.4245 39.7139 48.446C39.8052 48.4716 39.8623 48.3764 39.8623 48.3764V48.2741V48.1719C39.8623 48.1719 39.8052 48.0767 39.7139 48.1023Z",
    fill: "#DD884E"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2857 48.4462C41.3625 48.4246 41.4329 48.3176 41.4532 48.2843C41.457 48.278 41.457 48.2707 41.4532 48.2644C41.4329 48.2312 41.3626 48.124 41.2857 48.1025C41.1943 48.0769 41.1372 48.1721 41.1372 48.1721V48.2744V48.3766C41.1372 48.3766 41.1943 48.4718 41.2857 48.4462Z",
    fill: "#DD884E"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1569 48.3764H39.843C39.7865 48.3764 39.7407 48.3306 39.7407 48.2741C39.7407 48.2176 39.7865 48.1719 39.843 48.1719H41.1569C41.2134 48.1719 41.2591 48.2176 41.2591 48.2741C41.2591 48.3304 41.2134 48.3764 41.1569 48.3764Z",
    fill: "#774A2B"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 43.1419C40.4998 43.1419 40.3896 43.3956 40.3662 44.2504C40.3417 45.1456 40.4019 46.5059 40.4019 46.5059C40.4019 46.5059 40.5779 46.934 40.6587 47.5424C40.7011 47.8622 40.7062 48.0356 40.7062 48.0356L40.9792 47.8766C40.9792 47.8766 40.8917 47.4529 40.8595 47.3123C40.7379 46.7814 40.5989 46.4984 40.5989 46.4984C40.5989 46.4984 40.4864 45.279 40.5 44.1025C40.5073 43.4662 40.599 43.0491 40.599 43.0491C40.599 43.0491 40.5179 43.0456 40.4998 43.1419Z",
    fill: "#7A2B2B"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9912 20.1337C26.7413 18.3525 23.912 18.1687 23.912 18.1687C23.912 18.1687 21.0829 18.3524 20.8328 20.1337C20.6328 21.5588 21.8528 23.662 22.7261 24.9487H23.9119H25.0976C25.9712 23.6621 27.1912 21.5588 26.9912 20.1337Z",
    fill: "#F4E6AB"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5984 22.3116C25.5356 21.8646 25.1761 21.6012 24.8051 21.4471C24.2358 21.2107 23.5881 21.2107 23.0189 21.4471C22.6478 21.6012 22.2883 21.8646 22.2256 22.3116C22.116 23.0921 22.7841 24.2441 23.2625 24.9487H23.912H24.5614C25.0396 24.2441 25.708 23.0921 25.5984 22.3116Z",
    fill: "#FFF8BD"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7204 23.6847C24.6908 23.4743 24.5243 23.3487 24.3499 23.2743C24.0718 23.1556 23.7524 23.1556 23.4742 23.2743C23.2998 23.3487 23.1331 23.4742 23.1036 23.6847C23.0511 24.0588 23.3715 24.6111 23.6007 24.9489H23.9121H24.2235C24.4527 24.6111 24.7731 24.059 24.7204 23.6847Z",
    fill: "#FFFCEA"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 16.2928V0H23.8227V16.2926C23.7461 16.3267 23.6921 16.4029 23.6921 16.4922C23.6921 16.6131 23.7902 16.711 23.911 16.711C24.032 16.711 24.1299 16.613 24.1299 16.4922C24.1301 16.403 24.0763 16.327 23.9998 16.2928Z",
    fill: "#E4A553"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3225 18.7929H21.5017C21.5017 18.0905 21.9161 17.5673 22.4009 17.1961C23.0857 16.6713 23.9113 16.4473 23.9113 16.4473C23.9113 16.4473 26.3225 17.1001 26.3225 18.7929Z",
    fill: "#E4A553"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.9122 16.4944C22.2715 17.1465 22.2029 18.6963 22.2029 18.6963H23.9122H25.6214C25.6214 18.6963 25.5526 17.1465 23.9122 16.4944Z",
    fill: "#E4A553"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.4214 17.196C25.4214 17.196 25.7414 18.0392 23.9111 18.0392C22.0809 18.0392 22.4009 17.196 22.4009 17.196C21.9161 17.5672 21.5017 18.0904 21.5017 18.7928H23.9111H23.9113H26.3207C26.3206 18.0904 25.9062 17.5672 25.4214 17.196Z",
    fill: "#E4A553"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M26.322 18.7927H21.5012C21.5012 18.7927 20.4786 19.6839 20.7474 21.0716C21.0133 22.4594 22.6465 24.9924 22.6465 24.9924H25.1767C25.1767 24.9924 26.81 22.4593 27.0757 21.0716C27.3445 19.6838 26.322 18.7927 26.322 18.7927ZM22.7663 24.9166C20.3881 21.2294 20.9402 20.1337 20.9402 20.1337C20.9402 20.1337 21.2149 20.3062 21.7145 21.1007C22.1439 21.7874 23.1578 24.9164 23.1578 24.9164H22.7663V24.9166ZM23.3273 24.9166C23.3273 24.9166 22.0943 21.6092 22.4741 20.9167C22.7897 20.1951 23.9116 19.6604 23.9116 19.6604C23.9116 19.6604 25.0335 20.1951 25.349 20.9167C25.726 21.6092 24.4959 24.9166 24.4959 24.9166H23.3273ZM25.0569 24.9166H24.6682C24.6682 24.9166 25.6791 21.7874 26.1085 21.1009C26.6111 20.3062 26.8828 20.1338 26.8828 20.1338C26.8828 20.1338 27.4351 21.2294 25.0569 24.9166Z",
    fill: "#E4A553"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2808 25.5208C25.092 25.8248 23.9112 26.148 23.9112 26.148C23.9112 26.148 22.7304 25.8248 22.5432 25.5208C22.428 25.3352 22.476 25.1896 22.54 25.0984C22.588 25.0296 22.6456 24.9912 22.6456 24.9912H25.1784C25.1784 24.9912 25.484 25.1944 25.2808 25.5208Z",
    fill: "#E4A553"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3016 25.0981H22.5227C22.4729 25.0981 22.4326 25.0578 22.4326 25.008V25.0056C22.4326 24.9558 22.4729 24.9155 22.5227 24.9155H25.3016C25.3513 24.9155 25.3917 24.9558 25.3917 25.0056V25.008C25.3917 25.0578 25.3513 25.0981 25.3016 25.0981Z",
    fill: "#E4A553"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4387 18.8788H21.3851C21.3347 18.8788 21.2937 18.838 21.2937 18.7874C21.2937 18.737 21.3347 18.696 21.3851 18.696H26.4387C26.4891 18.696 26.53 18.737 26.53 18.7874C26.53 18.838 26.4892 18.8788 26.4387 18.8788Z",
    fill: "#E4A553"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.1788 18.8789H23.9112H21.6435C21.6435 18.8789 21.2691 19.168 21.0547 19.7797C21.0547 19.7797 21.8102 20.3138 22.0214 20.9621C22.0214 20.9621 22.164 20.3047 22.762 19.9205C23.2772 19.5895 23.9113 19.2365 23.9113 19.2365C23.9113 19.2365 24.5454 19.5895 25.0606 19.9205C25.6587 20.3048 25.8012 20.9621 25.8012 20.9621C26.0124 20.3138 26.768 19.7797 26.768 19.7797C26.5532 19.168 26.1788 18.8789 26.1788 18.8789Z",
    fill: "#E4A553"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.6415 25.0981H23.911H23.1806C23.1806 25.0981 22.8747 25.7621 23.911 25.7621C24.9475 25.7623 24.6415 25.0981 24.6415 25.0981Z",
    fill: "#E4A553"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.2823 25.0984H24.9399C24.9399 25.0984 25.1239 25.8232 23.9113 25.8232C22.6986 25.8232 22.8826 25.0984 22.8826 25.0984H22.5402C22.4762 25.1896 22.4282 25.3352 22.5434 25.5208C22.7305 25.8245 23.9089 26.1473 23.9113 26.148H23.9115C23.9139 26.1473 25.0924 25.8246 25.2794 25.5208C25.3943 25.3352 25.3463 25.1896 25.2823 25.0984Z",
    fill: "#E4A553"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1778 13.026C48.9709 11.5524 46.6302 11.4004 46.6302 11.4004C46.6302 11.4004 44.2896 11.5524 44.0827 13.026C43.9173 14.205 44.9266 15.9452 45.6491 17.0097H46.6302H47.6114C48.3338 15.9452 49.3432 14.205 49.1778 13.026Z",
    fill: "#F4E6AB"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0256 14.8279C47.9738 14.458 47.6763 14.2401 47.3693 14.1127C46.8984 13.9172 46.3624 13.9172 45.8915 14.1127C45.5845 14.2402 45.2872 14.4581 45.2352 14.8279C45.1446 15.4737 45.6974 16.4266 46.0931 17.0097H46.6304H47.1677C47.5634 16.4266 48.1163 15.4737 48.0256 14.8279Z",
    fill: "#FFF8BD"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2991 15.9637C47.2746 15.7897 47.1369 15.6858 46.9925 15.6242C46.7625 15.526 46.4981 15.526 46.2681 15.6242C46.1237 15.6858 45.986 15.7897 45.9615 15.9637C45.9181 16.2733 46.1831 16.7301 46.3727 17.0097H46.6303H46.8879C47.0775 16.7301 47.3425 16.2732 47.2991 15.9637Z",
    fill: "#FFFCEA"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M46.703 9.84832V0H46.5565V9.84816C46.4931 9.87632 46.4485 9.93936 46.4485 10.0133C46.4485 10.1133 46.5296 10.1944 46.6296 10.1944C46.7296 10.1944 46.8107 10.1133 46.8107 10.0133C46.8107 9.93952 46.7662 9.87648 46.703 9.84832Z",
    fill: "#E4A553"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6247 11.9167H44.6362C44.6362 11.3356 44.9791 10.9028 45.3802 10.5956C45.9468 10.1614 46.6298 9.97607 46.6298 9.97607C46.6298 9.97607 48.6247 10.5162 48.6247 11.9167Z",
    fill: "#E4A553"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.6304 10.0151C45.2731 10.5547 45.2163 11.8369 45.2163 11.8369H46.6304H48.0445C48.0445 11.8369 47.9877 10.5547 46.6304 10.0151Z",
    fill: "#E4A553"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.8791 10.5955C47.8791 10.5955 48.1438 11.2931 46.6297 11.2931C45.1154 11.2931 45.3802 10.5955 45.3802 10.5955C44.9791 10.9025 44.6362 11.3355 44.6362 11.9166H46.6297H46.6298H48.6231C48.6231 11.3355 48.2802 10.9025 47.8791 10.5955Z",
    fill: "#E4A553"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6241 11.9165H44.6358C44.6358 11.9165 43.7897 12.6538 44.0121 13.8019C44.2321 14.9501 45.5833 17.0458 45.5833 17.0458H47.6766C47.6766 17.0458 49.0278 14.9501 49.2478 13.8019C49.4702 12.6538 48.6241 11.9165 48.6241 11.9165ZM45.6823 16.9831C43.7147 13.9325 44.1716 13.0261 44.1716 13.0261C44.1716 13.0261 44.3988 13.1688 44.8121 13.8263C45.1675 14.3943 46.0062 16.9831 46.0062 16.9831H45.6823ZM46.1465 16.9831C46.1465 16.9831 45.1265 14.2467 45.4407 13.6739C45.7019 13.077 46.63 12.6346 46.63 12.6346C46.63 12.6346 47.5582 13.077 47.8193 13.6739C48.1311 14.2467 47.1135 16.9831 47.1135 16.9831H46.1465ZM47.5774 16.9831H47.2559C47.2559 16.9831 48.0923 14.3943 48.4476 13.8263C48.8633 13.1688 49.0881 13.0261 49.0881 13.0261C49.0881 13.0261 49.5451 13.9325 47.5774 16.9831Z",
    fill: "#E4A553"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7627 17.483C47.6066 17.7345 46.6296 18.0019 46.6296 18.0019C46.6296 18.0019 45.6526 17.7345 45.4978 17.483C45.4024 17.3294 45.4421 17.2089 45.495 17.1336C45.5347 17.0766 45.5824 17.0449 45.5824 17.0449H47.6779C47.6779 17.0449 47.9309 17.2129 47.7627 17.483Z",
    fill: "#E4A553"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7798 17.1331H45.4808C45.4397 17.1331 45.4062 17.0999 45.4062 17.0586V17.0565C45.4062 17.0154 45.4397 16.9819 45.4808 16.9819H47.7798C47.821 16.9819 47.8544 17.0152 47.8544 17.0565V17.0586C47.8544 17.0999 47.8211 17.1331 47.7798 17.1331Z",
    fill: "#E4A553"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7208 11.988H44.5399C44.4981 11.988 44.4644 11.9542 44.4644 11.9124C44.4644 11.8707 44.4981 11.8369 44.5399 11.8369H48.7208C48.7626 11.8369 48.7964 11.8707 48.7964 11.9124C48.7965 11.954 48.7626 11.988 48.7208 11.988Z",
    fill: "#E4A553"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.5056 11.9878H46.6295H44.7533C44.7533 11.9878 44.4436 12.227 44.2661 12.7331C44.2661 12.7331 44.8912 13.175 45.066 13.7113C45.066 13.7113 45.1839 13.1675 45.6788 12.8496C46.105 12.5756 46.6296 12.2836 46.6296 12.2836C46.6296 12.2836 47.1541 12.5756 47.5805 12.8496C48.0752 13.1675 48.1933 13.7113 48.1933 13.7113C48.368 13.175 48.9932 12.7331 48.9932 12.7331C48.8152 12.227 48.5056 11.9878 48.5056 11.9878Z",
    fill: "#E4A553"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.2338 17.1331H46.6294H46.0251C46.0251 17.1331 45.772 17.6825 46.6294 17.6825C47.4869 17.6825 47.2338 17.1331 47.2338 17.1331Z",
    fill: "#E4A553"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.7638 17.1335H47.4805C47.4805 17.1335 47.6326 17.7332 46.6294 17.7332C45.6261 17.7332 45.7784 17.1335 45.7784 17.1335H45.495C45.4421 17.2091 45.4024 17.3294 45.4978 17.483C45.6525 17.7342 46.6274 18.0014 46.6294 18.0019H46.6296H46.6298C46.6317 18.0014 47.6067 17.7342 47.7614 17.483C47.8565 17.3294 47.8168 17.2089 47.7638 17.1335Z",
    fill: "#E4A553"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2255 24.2905C59.0639 23.1387 57.2343 23.0198 57.2343 23.0198C57.2343 23.0198 55.4047 23.1387 55.2431 24.2905C55.1138 25.2121 55.9028 26.5723 56.4674 27.4043H57.2343H58.0012C58.5658 26.5723 59.3548 25.2121 59.2255 24.2905Z",
    fill: "#F4E6AB"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3248 25.6992C58.2842 25.41 58.0517 25.2398 57.8119 25.1401C57.4437 24.9872 57.0248 24.9872 56.6567 25.1401C56.4167 25.2398 56.1842 25.41 56.1437 25.6992C56.0728 26.204 56.505 26.9489 56.8143 27.4046H57.2343H57.6543C57.9636 26.9488 58.3957 26.2038 58.3248 25.6992Z",
    fill: "#FFF8BD"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7571 26.5868C57.738 26.4508 57.6302 26.3695 57.5174 26.3215C57.3375 26.2447 57.131 26.2447 56.9511 26.3215C56.8383 26.3697 56.7307 26.4508 56.7115 26.5868C56.6775 26.8287 56.8846 27.1858 57.0329 27.4042H57.2342H57.4355C57.5839 27.1858 57.791 26.8287 57.7571 26.5868Z",
    fill: "#FFFCEA"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2909 21.8067V0H57.1764V21.8067C57.1268 21.8288 57.092 21.8781 57.092 21.9357C57.092 22.0139 57.1554 22.0773 57.2336 22.0773C57.3119 22.0773 57.3752 22.0139 57.3752 21.9357C57.3752 21.8781 57.3405 21.8288 57.2909 21.8067Z",
    fill: "#E4A553"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M58.793 23.4235H55.6755C55.6755 22.9693 55.9435 22.6309 56.257 22.3909C56.6999 22.0515 57.2338 21.9067 57.2338 21.9067C57.2338 21.9067 58.793 22.3288 58.793 23.4235Z",
    fill: "#E4A553"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.2344 21.937C56.1735 22.3588 56.1292 23.361 56.1292 23.361H57.2344H58.3397C58.3397 23.361 58.2952 22.3588 57.2344 21.937Z",
    fill: "#E4A553"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.2103 22.3909C58.2103 22.3909 58.4171 22.9361 57.2336 22.9361C56.0499 22.9361 56.257 22.3909 56.257 22.3909C55.9435 22.6309 55.6755 22.9693 55.6755 23.4235H57.2336H57.2338H58.7919C58.7919 22.9693 58.5239 22.6309 58.2103 22.3909Z",
    fill: "#E4A553"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7927 23.4233H55.6753C55.6753 23.4233 55.014 23.9997 55.1878 24.8971C55.3598 25.7945 56.416 27.4326 56.416 27.4326H58.0521C58.0521 27.4326 59.1083 25.7945 59.2803 24.8971C59.454 23.9997 58.7927 23.4233 58.7927 23.4233ZM56.4934 27.3835C54.9555 24.9992 55.3126 24.2905 55.3126 24.2905C55.3126 24.2905 55.4902 24.4021 55.8132 24.916C56.091 25.36 56.7465 27.3835 56.7465 27.3835H56.4934ZM56.8561 27.3835C56.8561 27.3835 56.0588 25.2448 56.3044 24.7969C56.5084 24.3302 57.234 23.9845 57.234 23.9845C57.234 23.9845 57.9596 24.3302 58.1636 24.7969C58.4073 25.2448 57.6119 27.3835 57.6119 27.3835H56.8561ZM57.9747 27.3835H57.7233C57.7233 27.3835 58.3771 25.36 58.6548 24.916C58.9798 24.4021 59.1555 24.2905 59.1555 24.2905C59.1555 24.2905 59.5126 24.9992 57.9747 27.3835Z",
    fill: "#E4A553"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1194 27.7743C57.9973 27.9709 57.2338 28.1799 57.2338 28.1799C57.2338 28.1799 56.4703 27.9709 56.3492 27.7743C56.2746 27.6543 56.3056 27.56 56.3471 27.5012C56.3781 27.4567 56.4154 27.4319 56.4154 27.4319H58.0533C58.0533 27.4319 58.2509 27.5632 58.1194 27.7743Z",
    fill: "#E4A553"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1328 27.5009H56.3358C56.3037 27.5009 56.2776 27.4748 56.2776 27.4427V27.4411C56.2776 27.4089 56.3037 27.3828 56.3358 27.3828H58.1328C58.1649 27.3828 58.191 27.4089 58.191 27.4411V27.4427C58.191 27.4748 58.1651 27.5009 58.1328 27.5009Z",
    fill: "#E4A553"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8683 23.4789H55.6003C55.5677 23.4789 55.5413 23.4525 55.5413 23.4199C55.5413 23.3872 55.5677 23.3608 55.6003 23.3608H58.8683C58.9009 23.3608 58.9273 23.3872 58.9273 23.4199C58.9273 23.4525 58.9009 23.4789 58.8683 23.4789Z",
    fill: "#E4A553"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.7001 23.479H57.2337H55.7673C55.7673 23.479 55.5252 23.666 55.3865 24.0616C55.3865 24.0616 55.8751 24.407 56.0116 24.8262C56.0116 24.8262 56.1038 24.4011 56.4905 24.1526C56.8236 23.9385 57.2337 23.7104 57.2337 23.7104C57.2337 23.7104 57.6438 23.9387 57.9769 24.1526C58.3636 24.4011 58.4559 24.8262 58.4559 24.8262C58.5924 24.407 59.081 24.0616 59.081 24.0616C58.9422 23.666 58.7001 23.479 58.7001 23.479Z",
    fill: "#E4A553"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.7059 27.501H57.2335H56.7611C56.7611 27.501 56.5634 27.9304 57.2335 27.9304C57.9039 27.9304 57.7059 27.501 57.7059 27.501Z",
    fill: "#E4A553"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.1205 27.5012H57.8991C57.8991 27.5012 58.0181 27.9699 57.2338 27.97C56.4496 27.97 56.5685 27.5012 56.5685 27.5012H56.3471C56.3056 27.5603 56.2746 27.6543 56.3492 27.7743C56.4701 27.9707 57.2322 28.1795 57.2336 28.1799H57.2338C57.2354 28.1795 57.9973 27.9708 58.1183 27.7743C58.193 27.6543 58.1619 27.5603 58.1205 27.5012Z",
    fill: "#E4A553"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_596_955",
    x1: 34.5384,
    y1: 44.3582,
    x2: 40.4999,
    y2: 44.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9824C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DE97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNimaz);
export default __webpack_public_path__ + "static/media/nimaz.86174048c5f8e8a84764d3c3244e2774.svg";
export { ForwardRef as ReactComponent };